// import { useState, useEffect, useRef } from "react";
// import {
//   Modal,
//   Button,
//   Nav,
//   Dropdown,
//   Row,
//   Col,
//   Spinner,
//   Form,
//   Alert,
// } from "react-bootstrap";
// import {
//   ArrowLeft,
//   User,
//   FileText,
//   Star,
//   Phone,
//   Mail,
//   ChevronDown,
//   Copy,
//   Share2,
//   Edit3,
//   Trophy,
//   UserCheck,
//   Download,
//   Briefcase,
//   X,
//   AlertCircle,
// } from "lucide-react";
// import { toast } from "react-toastify";
// import AsyncSelectDropdown from "../../../components/common/FormFields/AysncSelectDropdown.jsx";
// import CommentsSection from "../../commentSection/CommentSection.jsx";

// // Correct imports exactly matching admin dashboard
// import { getattendances } from "../../../../services/MarkattendancesService";
// import { getStudentQuizSubmissions } from "../../../../services/StudentQuizService.js";
// import { getBatchQuizHistories } from "../../../../services/BatchQuizHistoryService.js";
// import { getQuizzes } from "../../../../services/QuizService.js";
// import AppliedStudentsView from "./AppliedStudentsView.jsx";

// import {
//   getOrganizations,
//   updateOrganization,
// } from "../../../../services/organizationServices.js";

// // Import the CSS file for styling (same as PlacementPopup)
// import "../../placement/placementpopup/PlacementPopup.css";
// import PlacementPopupView from "../../placement/placementpopup/PlacementPopupView.jsx";
// import OrganizationPopupView from "../../organization/organizationpopup/OrganizationPopupView.jsx";
// import { getStudentAppliedJobs } from "../../../../services/AppliedStudentsService.js";
// import { getPlacementOfficers } from "../../../../services/PlacementOfficerServices.js";
// import { getContacts } from "../../../../services/contactServices.js";
// import { getBatches } from "../../../../services/BatchService";
// import { getPlacements } from "../../../../services/placementServices.js";
// import { getcourses, getDepartmentsV2, getBranchesV2 } from "../../../../services/CourseModule.js";

// // ── Helper: map jobProfileId array (from API) into the appliedJobs shape the table expects ──
// const mapJobProfileIdsToAppliedJobs = (jobProfileIdArray = []) => {
//   return jobProfileIdArray.map((job) => ({
//     id: job.id,
//     jobName: job.jobName,
//     jobLocation: job.jobLocation,
//     status: job.status,
//     salary: job.salary,
//     jobPostedDate: job.jobPostedDate,
//     jobPositionStatus: job.jobPositionStatus,
//     contactId: job.contactId,
//     // organizationId array: [{name, id}] — flatten to scalar + name for table display
//     organizationId: job.organizationId?.[0]?.id || null,
//     organizationName: job.organizationId?.[0]?.name || "N/A",
//     // department array: [{name, id}] — flatten to scalar + name for table display
//     department: job.department?.[0]?.name || null,
//     departmentName: job.department?.[0]?.name || "N/A",
//   }));
// };

// const StudentPopupView = ({
//   student,
//   isVisible,
//   onClose,
//   onCloseAll, // Add this prop
//   onUpdate,
//   users: externalUsers = [],
//   contacts: externalContacts = [],
//   courses: externalCourses = [],
//   departments: externalDepartments = [],
//   branches: externalBranches = [],
//   batches: externalBatches = [],
//   jobProfiles: externalJobProfiles = [],
//   defaultActiveTab = "details",
// }) => {
//   const [localUsers, setLocalUsers] = useState([]);
//   const [localContacts, setLocalContacts] = useState([]);
//   const [localCourses, setLocalCourses] = useState([]);
//   const [localDepartments, setLocalDepartments] = useState([]);
//   const [localBranches, setLocalBranches] = useState([]);
//   const [localBatches, setLocalBatches] = useState([]);
//   const [localJobProfiles, setLocalJobProfiles] = useState([]);

//   const users = localUsers.length > 0 ? localUsers : (externalUsers || []);
//   const contacts = localContacts.length > 0 ? localContacts : (externalContacts || []);
//   const courses = localCourses.length > 0 ? localCourses : (externalCourses || []);
//   const departments = localDepartments.length > 0 ? localDepartments : (externalDepartments || []);
//   const branches = localBranches.length > 0 ? localBranches : (externalBranches || []);
//   const batches = localBatches.length > 0 ? localBatches : (externalBatches || []);
//   const jobProfiles = localJobProfiles.length > 0 ? localJobProfiles : (externalJobProfiles || []);

//   const [activeTab, setActiveTab] = useState(defaultActiveTab);
//   const [editMode, setEditMode] = useState(false);
//   const [formData, setFormData] = useState({});
//   const [originalFormData, setOriginalFormData] = useState({});
//   const [quizData, setQuizData] = useState([]);
//   const [attendanceData, setAttendanceData] = useState({
//     totalPresent: 0,
//     totalAbsent: 0,
//     totalLectures: 0,
//     attendancePercentage: 0,
//     recentRecords: [],
//     batchWiseData: [],
//   });
//   const [appliedJobsData, setAppliedJobsData] = useState([]);
//   const [filteredStudents, setFilteredStudents] = useState([]);
//   const [loadingQuiz, setLoadingQuiz] = useState(false);
//   const [loadingAttendance, setLoadingAttendance] = useState(false);
//   const [loadingAppliedJobs, setLoadingAppliedJobs] = useState(false);
//   const [loadingTab, setLoadingTab] = useState(false);
//   const [isStarred, setIsStarred] = useState(false);
//   const [error, setError] = useState(null);

//   const [jobTitleFilter, setJobTitleFilter] = useState("");
//   const [companyFilter, setCompanyFilter] = useState("");

//   const [quizDataLoaded, setQuizDataLoaded] = useState(false);
//   const [attendanceDataLoaded, setAttendanceDataLoaded] = useState(false);
//   const [appliedJobsDataLoaded, setAppliedJobsDataLoaded] = useState(false);

//   const [showAppliedStudentsModal, setShowAppliedStudentsModal] =
//     useState(false);
//   const [selectedJobProfile, setSelectedJobProfile] = useState(null);

//   // NEW STATE FOR DOWNLOAD RESUME MODAL
//   const [showDownloadResumeModal, setShowDownloadResumeModal] = useState(false);
//   const [resumeDownloadOptions, setResumeDownloadOptions] = useState([]);

//   const [showPlacementPopup, setShowPlacementPopup] = useState(false);
//   const [selectedPlacementForPopup, setSelectedPlacementForPopup] =
//     useState(null);
//   const [defaultActiveTabForPlacement, setDefaultActiveTabForPlacement] =
//     useState("summary");

//   // Add these after setDefaultActiveTabForPlacement state
//   const [organizations, setOrganizations] = useState([]);
//   const [selectedOrganizationForPopup, setSelectedOrganizationForPopup] =
//     useState(null);
//   const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
//   const [defaultActiveOrgTab, setDefaultActiveOrgTab] = useState("summary");

//   // Helper functions to get names by ID
//   const getCourseNameById = (course) => {
//     if (!course) return "N/A";

//     // If it's already an array/object with a name, use it
//     const name = Array.isArray(course) ? course[0]?.courseName || course[0]?.name : (typeof course === 'object' ? course?.courseName || course?.name : null);
//     if (name) return name;

//     // If it's a string, check if it's an ID or a name
//     if (typeof course === 'string') {
//       // If it's not a 24-char hex ID, assume it's already a name
//       if (course.length !== 24 || !/^[0-9a-fA-F]+$/.test(course)) {
//         return course;
//       }
//     }

//     const courseId = Array.isArray(course) ? course[0]?.id : (typeof course === 'object' ? course?.id : course);
//     if (!courseId || !courses.length) return "N/A";

//     const matchedCourse = courses.find(
//       (c) => c.id === parseInt(courseId) || c.id === courseId,
//     );
//     return matchedCourse ? matchedCourse.courseName || matchedCourse.name : "N/A";
//   };

//   const getCourseNameByCourseModuleId = (course) => {
//     if (!course) return "N/A";

//     // If it's already an array/object with a name, use it
//     const name = Array.isArray(course) ? course[0]?.courseName || course[0]?.name : (typeof course === 'object' ? course?.courseName || course?.name : null);
//     if (name) return name;

//     // If it's a string, check if it's an ID or a name
//     if (typeof course === 'string') {
//       // If it's not a 24-char hex ID, assume it's already a name
//       if (course.length !== 24 || !/^[0-9a-fA-F]+$/.test(course)) {
//         return course;
//       }
//     }

//     const courseId = Array.isArray(course) ? course[0]?.id : (typeof course === 'object' ? course?.id : course);
//     if (!courseId || !courses.length) return "N/A";

//     // Find course where courseModuleIds matches the courseId
//     const matchedCourse = courses.find((c) => {
//       if (
//         c.courseModuleIds === courseId ||
//         c.courseModuleIds === courseId.toString()
//       ) {
//         return true;
//       }
//       if (
//         typeof c.courseModuleIds === "string" &&
//         c.courseModuleIds.includes(courseId.toString())
//       ) {
//         return true;
//       }
//       return false;
//     });

//     return matchedCourse ? matchedCourse.courseName || matchedCourse.name : "N/A";
//   };

//   const getDepartmentNameById = (dept) => {
//     if (!dept) return "N/A";

//     // If it's already an array/object with a name, use it
//     const name = Array.isArray(dept) ? dept[0]?.name || dept[0]?.departmentName : (typeof dept === 'object' ? dept?.name || dept?.departmentName : null);
//     if (name && typeof name === 'string') return name;

//     // If it's a string, check if it's an ID or a name
//     if (typeof dept === 'string') {
//       // If it's not a 24-char hex ID, assume it's already a name
//       if (dept.length !== 24 || !/^[0-9a-fA-F]+$/.test(dept)) {
//         return dept;
//       }
//     }

//     const departmentId = Array.isArray(dept) ? dept[0]?.id : (typeof dept === 'object' ? dept?.id : dept);

//     // Safety check: if departmentId is an object, try to get its id
//     const finalId = (typeof departmentId === 'object' && departmentId !== null) ? departmentId.id : departmentId;

//     if (!finalId || !departments.length) return "N/A";

//     const department = departments.find((d) => {
//       const targetId = d.id;
//       return (
//         targetId === finalId ||
//         targetId === parseInt(finalId) ||
//         targetId === String(finalId)
//       );
//     });

//     if (department) {
//       return department.departmentName || department.name || "Unknown";
//     }

//     return "N/A";
//   };

//   // Add this function after getDepartmentNameById
//   const loadOrganizations = async () => {
//     try {
//       const response = await getOrganizations(1000, 1, "");
//       if (response && response.data && Array.isArray(response.data)) {
//         setOrganizations(response.data);
//       } else {
//         setOrganizations([]);
//       }
//     } catch (error) {
//       console.error("Failed to load organizations:", error);
//       setOrganizations([]);
//     }
//   };

//   const getBranchNameById = (branch) => {
//     if (!branch) return "N/A";

//     // If it's already an array/object with a name, use it
//     const name = Array.isArray(branch) ? branch[0]?.name || branch[0]?.branchName : (typeof branch === 'object' ? branch?.name || branch?.branchName : null);
//     if (name && typeof name === 'string') return name;

//     // If it's a string, check if it's an ID or a name
//     if (typeof branch === 'string') {
//       // If it's not a 24-char hex ID, assume it's already a name
//       if (branch.length !== 24 || !/^[0-9a-fA-F]+$/.test(branch)) {
//         return branch;
//       }
//     }

//     const branchId = Array.isArray(branch) ? branch[0]?.id : (typeof branch === 'object' ? branch?.id : branch);

//     // Safety check: if branchId is an object, try to get its id
//     const finalId = (typeof branchId === 'object' && branchId !== null) ? branchId.id : branchId;

//     if (!finalId || !branches.length) return "N/A";

//     const foundBranch = branches.find((b) => {
//       const targetId = b.id;
//       return (
//         targetId === finalId ||
//         targetId === parseInt(finalId) ||
//         targetId === String(finalId)
//       );
//     });

//     if (foundBranch) {
//       return foundBranch.branchName || foundBranch.name || "Unknown";
//     }

//     return "N/A";
//   };

//   const handleCommentsError = (error) => {
//     setError(error);
//   };

//   const getFilteredAppliedJobs = () => {
//     if (!appliedJobsData.length) return [];

//     return appliedJobsData.filter((job) => {
//       const jobTitleMatch =
//         jobTitleFilter === "" ||
//         job.jobName?.toLowerCase().includes(jobTitleFilter.toLowerCase());
//       const companyMatch =
//         companyFilter === "" ||
//         job.organizationName
//           ?.toLowerCase()
//           .includes(companyFilter.toLowerCase());
//       return jobTitleMatch && companyMatch;
//     });
//   };

//   const getDepartmentOptions = () => {
//     return departments.map((dept) => ({
//       value: dept.id,
//       label: dept.departmentName || dept.name,
//     }));
//   };

//   const getBranchOptions = () => {
//     return branches.map((branch) => ({
//       value: branch.id,
//       label: branch.branchName || branch.name,
//     }));
//   };

//   const getCourseOptions = (excludeValues = []) => {
//     return courses
//       .filter((course) => !excludeValues.includes(course.id))
//       .map((course) => ({
//         value: course.id,
//         label: course.courseName || course.name,
//       }));
//   };

//   const getSelectedDepartmentOption = () => {
//     if (!formData.department) return null;
//     return getDepartmentOptions().find(
//       (option) => option.value === formData.department,
//     );
//   };

//   const getSelectedBranchOption = () => {
//     if (!formData.selectBranch) return null;
//     return getBranchOptions().find(
//       (option) => option.value === formData.selectBranch,
//     );
//   };

//   const getSelectedCourseOption = (courseField) => {
//     if (!formData[courseField]) return null;
//     const allCourseOptions = courses.map((course) => ({
//       value: course.id,
//       label: course.courseName || course.name,
//     }));
//     return allCourseOptions.find(
//       (option) => option.value === formData[courseField],
//     );
//   };

//   const handleJobProfileClick = (job) => {
//     setSelectedJobProfile(job);
//     setShowAppliedStudentsModal(true);
//   };

//   // Function to handle closing all modals in chain
//   const handleCloseAllModals = () => {
//     // First close the AppliedStudentsView modal if it's open
//     setShowAppliedStudentsModal(false);
//     setSelectedJobProfile(null);

//     // Then close all parent modals
//     if (onCloseAll) {
//       onCloseAll();
//     } else {
//       onClose();
//     }
//   };

//   // / Handle update placement from popup
//   const handleUpdatePlacementFromPopup = async (updatedPlacement) => {
//     try {
//       toast.success(
//         `Placement "${updatedPlacement.jobName}" updated successfully!`,
//       );

//       // Refresh the applied jobs data
//       setAppliedJobsData((prevData) =>
//         prevData.map((job) =>
//           job.id === updatedPlacement.id ? updatedPlacement : job,
//         ),
//       );
//     } catch (error) {
//       toast.error("Failed to update placement: " + error.message);
//     }
//   };

//   const handleJobClickForPlacement = (job) => {
//     try {
//       setSelectedPlacementForPopup(job);
//       setDefaultActiveTabForPlacement("summary");
//       setShowPlacementPopup(true);
//     } catch (error) {
//       console.error("Error opening placement details:", error);
//       toast.error("Failed to open placement details");
//     }
//   };

//   // Add these three handler functions
//   const handleViewOrganization = (organizationId) => {
//     const organization = organizations.find((org) => org.id === organizationId);
//     if (organization) {
//       setSelectedOrganizationForPopup(organization);
//       setDefaultActiveOrgTab("summary");
//       setShowOrganizationPopup(true);
//     }
//   };

//   const fetchState = useRef({ metadata: false, appliedJobs: false, quiz: false, attendance: false });
//   const lastStudentId = useRef(null);

//   const loadMinimalMetadataForDetails = async () => {
//     if (fetchState.current.metadata) return;
//     try {
//       // Only fetch what's needed for name resolution in Details tab
//       const [usersRes, coursesRes, branchesRes] = await Promise.all([
//         getPlacementOfficers(100, 1),
//         getcourses(1000, 1),
//         getBranchesV2(1000)
//       ]);

//       if (usersRes?.data) setLocalUsers(usersRes.data);
//       if (coursesRes?.data) setLocalCourses(coursesRes.data);
//       if (branchesRes) setLocalBranches(branchesRes);

//       fetchState.current.metadata = true;
//     } catch (error) {
//       console.error("Error loading minimal metadata:", error);
//     }
//   };

//   const handleCloseOrganizationPopup = () => {
//     setShowOrganizationPopup(false);
//     setSelectedOrganizationForPopup(null);
//     setDefaultActiveOrgTab("summary");
//   };

//   const handleUpdateOrganization = async (updatedOrganization) => {
//     try {
//       await updateOrganization(updatedOrganization.id, updatedOrganization);
//       await loadOrganizations();
//       setSelectedOrganizationForPopup(updatedOrganization);
//     } catch (error) {
//       console.error("Update failed:", error);
//     }
//   };

//   useEffect(() => {
//     if (student) {
//       const sid = student.studentId;
//       // Resolve studentId: prioritize student.id then fallback to studentId array/object
//       const studentId = student.id || (Array.isArray(sid) && sid.length > 0 ? (sid[0]?.id || sid[0]) : (sid?.id || sid));
//       const studentName = student.studentName || (Array.isArray(student.studentId) ? student.studentId[0]?.name : "") || "N/A";
//       const studentEmail = student.studentEmail || (Array.isArray(student.studentId) ? student.studentId[0]?.email : "") || "N/A";
//       const studentPhoneNumber = student.studentPhoneNumber || (Array.isArray(student.studentId) ? student.studentId[0]?.phone : "") || "N/A";

//       const studentData = {
//         id: student.id || "",
//         studentName: studentName,
//         studentId: studentId,
//         studentEmail: studentEmail,
//         studentPhoneNumber: studentPhoneNumber,
//         department: (Array.isArray(student.department) ? student.department[0]?.id : (typeof student.department === 'object' ? student.department?.id : student.department)) || "",
//         technologiesLearned: student.technologiesLearned || "",
//         addressWithPinCode: student.addressWithPinCode || "",
//         tenthPercentageAndYear: student.tenthPercentageAndYear || "",
//         twelfthPercentageAndYear: student.twelfthPercentageAndYear || "",
//         workExperience: student.workExperience || "",
//         course1: student.course1 || "",
//         course2: student.course2 || "",
//         course3: student.course3 || "",
//         graduationPercentageAndYear: student.graduationPercentageAndYear || "",
//         oneTimePlacementFee: student.oneTimePlacementFee || "",
//         selectBranch: (Array.isArray(student.selectBranch) ? student.selectBranch[0]?.id : (typeof student.selectBranch === 'object' ? student.selectBranch?.id : student.selectBranch)) || "",
//         postGraduationPercentageAndYear:
//           student.postGraduationPercentageAndYear || "",
//         cvUpload: student.cvUpload || "",
//         jobProfileId: (Array.isArray(student.jobProfileId) ? student.jobProfileId[0]?.id : student.jobProfileId) || "",
//         createdById: student.createdById || "",
//         updatedById: student.updatedById || "",
//       };
//       setFormData(studentData);
//       setOriginalFormData(studentData);

//       const isNewStudent = lastStudentId.current !== studentId;
//       if (isNewStudent) {
//         lastStudentId.current = studentId;
//         fetchState.current = { metadata: false, appliedJobs: false, quiz: false, attendance: false };
//         setQuizData([]);
//         setAttendanceData({
//           totalPresent: 0,
//           totalAbsent: 0,
//           totalLectures: 0,
//           attendancePercentage: 0,
//           recentRecords: [],
//           batchWiseData: [],
//         });
//         setQuizDataLoaded(false);
//         setAttendanceDataLoaded(false);
//         setAppliedJobsDataLoaded(false);
//       }

//       // ── Resolve appliedJobs ──────────────────────────────────────────────
//       if (isNewStudent || !appliedJobsDataLoaded) {
//         let resolvedAppliedJobs = [];
//         if (
//           Array.isArray(student.appliedJobs) &&
//           student.appliedJobs.length > 0
//         ) {
//           resolvedAppliedJobs = student.appliedJobs;
//         } else if (
//           Array.isArray(student.jobProfileId) &&
//           student.jobProfileId.length > 0
//         ) {
//           resolvedAppliedJobs = mapJobProfileIdsToAppliedJobs(
//             student.jobProfileId,
//           );
//         }

//         setAppliedJobsData(resolvedAppliedJobs);
//         if (resolvedAppliedJobs.length > 0) {
//           setAppliedJobsDataLoaded(true);
//           // If we have data, we don't need to fetch it again via lazy-loader
//           fetchState.current.appliedJobs = true;
//         }
//       }

//       if (isNewStudent) {
//         setJobTitleFilter("");
//         setCompanyFilter("");
//       }
//     }
//     setActiveTab(defaultActiveTab);
//     setEditMode(defaultActiveTab === "edit");
//   }, [student?.id, student?.studentId, defaultActiveTab]);

//   const fetchAllMetadata = async () => {
//     if (fetchState.current.metadata) return;
//     fetchState.current.metadata = true;
//     try {
//       const [usersRes, contactsRes, coursesRes, deptsRes, branchesRes, batchesRes, jobsRes] = await Promise.all([
//         getPlacementOfficers(500, 1),
//         getContacts(),
//         getcourses(1000, 1),
//         getDepartmentsV2(1000, 1),
//         getBranchesV2(1000),
//         getBatches(1000, 1),
//         getPlacements()
//       ]);

//       if (usersRes?.data) setLocalUsers(usersRes.data);
//       if (contactsRes?.data) setLocalContacts(contactsRes.data);
//       if (coursesRes?.data) setLocalCourses(coursesRes.data);
//       if (deptsRes?.data || deptsRes) setLocalDepartments(deptsRes?.data || deptsRes);
//       if (branchesRes) setLocalBranches(branchesRes);
//       if (batchesRes?.data) setLocalBatches(batchesRes.data);
//       if (jobsRes?.data) setLocalJobProfiles(jobsRes.data);

//       fetchState.current.metadata = true;
//     } catch (error) {
//       console.error("Error fetching metadata in StudentPopView:", error);
//     }
//   };

//   useEffect(() => {
//     if (isVisible) {
//       // Lazy load data based on the active tab
//       if (activeTab === "details") {
//         // No metadata calls needed for Details, data is already joined in the prop
//       } else if (activeTab === "edit") {
//         fetchAllMetadata();
//       } else if (activeTab === "applied-jobs") {
//         if (!fetchState.current.appliedJobs) {
//           fetchState.current.appliedJobs = true;
//           fetchAppliedJobsData();
//         }
//       } else if (activeTab === "quiz") {
//         if (!fetchState.current.quiz) {
//           fetchState.current.quiz = true;
//           fetchQuizData();
//         }
//       } else if (activeTab === "attendance") {
//         if (!fetchState.current.attendance) {
//           fetchState.current.attendance = true;
//           fetchAttendanceData();
//         }
//       }
//     }
//   }, [isVisible, activeTab, student?.id]);

//   const fetchAppliedJobsData = async () => {
//     if (!student || fetchState.current.appliedJobs || loadingAppliedJobs) return;

//     const sid = student.studentId;
//     // Resolve studentId: prioritize student.id then fallback to studentId array/object
//     const studentId = student.id || (Array.isArray(sid) && sid.length > 0) ? (sid[0]?.id || sid[0]) : (sid?.id || sid);
//     if (!studentId) return;

//     // Check if we already have this data in the student object
//     if (student.appliedJobs && student.appliedJobs.length > 0) {
//       setAppliedJobsData(student.appliedJobs);
//       setAppliedJobsDataLoaded(true);
//       fetchState.current.appliedJobs = true;
//       return;
//     }

//     fetchState.current.appliedJobs = true;
//     setLoadingAppliedJobs(true);

//     try {
//       const response = await getStudentAppliedJobs(studentId);
//       if (response && response.data) {
//         // Map the raw applications to the format expected by the view
//         const mappedJobs = response.data.map(app => {
//           const job = Array.isArray(app.jobProfileId) ? app.jobProfileId[0] : app.jobProfileId;
//           if (!job) return null;

//           return {
//             ...job,
//             applicationId: app.id,
//             appliedDate: app.createdAt,
//             organizationName: (Array.isArray(job.organizationId) ? job.organizationId[0]?.name : (job.organizationName || job.organizationId?.name)) || "N/A",
//             departmentName: (Array.isArray(job.department) ? job.department[0]?.name : (job.departmentName || job.department?.name)) || "N/A",
//           };
//         }).filter(Boolean);
//         setAppliedJobsData(mappedJobs);
//         setAppliedJobsDataLoaded(true);
//       }
//     } catch (error) {
//       console.error("Error fetching applied jobs:", error);
//       toast.error("Failed to load applied jobs: " + error.message);
//     } finally {
//       setLoadingAppliedJobs(false);
//     }
//   };

//   const fetchQuizData = async () => {
//     if (!student || fetchState.current.quiz || loadingQuiz) return;

//     fetchState.current.quiz = true;
//     setLoadingQuiz(true);
//     const sid = student.studentId;
//     const actualStudentId = student.id || (Array.isArray(sid) && sid.length > 0 ? (sid[0]?.id || sid[0]) : (sid?.id || sid));

//     try {
//       const allBatchIds = [];

//       batches.forEach((batch) => {
//         if (batch.userId) {
//           const studentIds = batch.userId.split(",").map((id) => id.trim());
//           if (studentIds.includes(actualStudentId)) {
//             allBatchIds.push(batch.id);
//           }
//         }
//       });

//       if (allBatchIds.length > 0) {
//         const [quizzesResponse, studentQuizResponse, batchQuizResponse] =
//           await Promise.allSettled([
//             getQuizzes(),
//             getStudentQuizSubmissions(actualStudentId),
//             getBatchQuizHistories(),
//           ]);

//         if (
//           studentQuizResponse.status === "fulfilled" &&
//           batchQuizResponse.status === "fulfilled" &&
//           quizzesResponse.status === "fulfilled"
//         ) {
//           const allQuizzes = quizzesResponse.value?.data || [];
//           const studentQuizzes = studentQuizResponse.value?.data || [];
//           const batchQuizzes = batchQuizResponse.value?.data || [];

//           const relevantBatchQuizzes = batchQuizzes.filter((batchQuiz) =>
//             allBatchIds.some(
//               (batchId) =>
//                 batchQuiz.batchIds === batchId ||
//                 batchQuiz.batchIds === batchId.toString() ||
//                 (typeof batchQuiz.batchIds === "string" &&
//                   batchQuiz.batchIds.includes(batchId.toString())),
//             ),
//           );

//           const relevantQuizIds = relevantBatchQuizzes.map((bq) => bq.quizId);
//           const studentQuizHistory = studentQuizzes.filter(
//             (quiz) =>
//               relevantQuizIds.includes(quiz.quizId) &&
//               quiz.studentId === actualStudentId,
//           );

//           const enrichedQuizData = studentQuizHistory.map((quiz) => {
//             const quizDetails = allQuizzes.find((q) => q.id === quiz.quizId);
//             const batchQuiz = relevantBatchQuizzes.find(
//               (bq) => bq.quizId === quiz.quizId,
//             );
//             const batchInfo = batches.find((b) => b.id === batchQuiz?.batchIds);

//             return {
//               ...quiz,
//               quizName:
//                 quizDetails?.title || quizDetails?.name || "Unknown Quiz",
//               batchName: batchInfo?.name || "Unknown Batch",
//               startDate: batchQuiz?.startDate,
//               endDate: batchQuiz?.endDate,
//             };
//           });

//           setQuizData(enrichedQuizData);
//           setQuizDataLoaded(true);
//         }
//       } else {
//         setQuizDataLoaded(true);
//       }
//     } catch (error) {
//       console.error("Error fetching quiz data:", error);
//       toast.error("Failed to load quiz data: " + error.message);
//     } finally {
//       setLoadingQuiz(false);
//     }
//   };

//   const fetchAttendanceData = async () => {
//     if (!student || fetchState.current.attendance || loadingAttendance) return;

//     fetchState.current.attendance = true;
//     setLoadingAttendance(true);
//     const sid = student.studentId;
//     const actualStudentId = student.id || (Array.isArray(sid) && sid.length > 0 ? (sid[0]?.id || sid[0]) : (sid?.id || sid));

//     try {
//       const allBatchIds = [];

//       batches.forEach((batch) => {
//         if (batch.userId) {
//           const studentIds = batch.userId.split(",").map((id) => id.trim());
//           if (studentIds.includes(actualStudentId)) {
//             allBatchIds.push(batch.id);
//           }
//         }
//       });

//       if (allBatchIds.length > 0) {
//         const attendanceResponse = await getattendances();
//         if (attendanceResponse?.data) {
//           const allAttendances = attendanceResponse.data;
//           let totalPresent = 0;
//           let totalAbsent = 0;
//           let totalLectures = 0;
//           const recentRecords = [];
//           const batchWiseData = [];

//           allBatchIds.forEach((batchId) => {
//             const batchInfo = batches.find((b) => b.id === batchId);
//             const batchAttendances = allAttendances.filter(
//               (record) =>
//                 record.batchId === batchId ||
//                 record.batchId === batchId.toString(),
//             );

//             let batchPresent = 0;
//             let batchAbsent = 0;
//             let batchLectures = 0;
//             const batchRecentRecords = [];

//             batchAttendances.forEach((record) => {
//               batchLectures++;
//               totalLectures++;
//               const userIdsArray = record.userIds
//                 ? record.userIds.split(",").map((id) => id.trim())
//                 : [];
//               const isPresent = userIdsArray.includes(actualStudentId);

//               if (isPresent) {
//                 batchPresent++;
//                 totalPresent++;
//               } else {
//                 batchAbsent++;
//                 totalAbsent++;
//               }

//               let subject = "N/A";
//               if (record.syllabusId) {
//                 const firstLine = record.syllabusId.split("\n")[0];
//                 const firstColonIndex = firstLine.indexOf(":");
//                 if (firstColonIndex !== -1) {
//                   subject = firstLine.substring(0, firstColonIndex).trim();
//                 } else {
//                   subject =
//                     firstLine.substring(0, 30) +
//                     (firstLine.length > 30 ? "..." : "");
//                 }
//               } else if (record.subject) {
//                 subject = record.subject;
//               }

//               const attendanceRecord = {
//                 date: record.date || record.createdAt,
//                 status: isPresent ? "Present" : "Absent",
//                 subject: subject,
//                 batchId: record.batchId,
//               };

//               batchRecentRecords.push(attendanceRecord);
//               recentRecords.push(attendanceRecord);
//             });

//             const batchPercentage =
//               batchLectures > 0
//                 ? ((batchPresent / batchLectures) * 100).toFixed(2)
//                 : 0;

//             batchWiseData.push({
//               batchId: batchId,
//               batchName: batchInfo?.name || `Batch ${batchId}`,
//               totalLectures: batchLectures,
//               totalPresent: batchPresent,
//               totalAbsent: batchAbsent,
//               attendancePercentage: batchPercentage,
//               recentRecords: batchRecentRecords
//                 .sort((a, b) => new Date(b.date) - new Date(a.date))
//                 .slice(0, 3),
//             });
//           });

//           const attendancePercentage =
//             totalLectures > 0
//               ? ((totalPresent / totalLectures) * 100).toFixed(2)
//               : 0;

//           setAttendanceData({
//             totalPresent,
//             totalAbsent,
//             totalLectures,
//             attendancePercentage,
//             recentRecords: recentRecords
//               .sort((a, b) => new Date(b.date) - new Date(a.date))
//               .slice(0, 5),
//             batchWiseData: batchWiseData,
//           });
//           setAttendanceDataLoaded(true);
//         }
//       } else {
//         setAttendanceDataLoaded(true);
//       }
//     } catch (error) {
//       console.error("Error fetching attendance data:", error);
//       toast.error("Failed to load attendance data: " + error.message);
//     } finally {
//       setLoadingAttendance(false);
//     }
//   };

//   const handleTabSelect = (key) => {
//     setLoadingTab(true);
//     setTimeout(() => {
//       setActiveTab(key);
//       setEditMode(key === "edit");
//       setLoadingTab(false);

//       if (key === "quiz" && !quizDataLoaded) {
//         setTimeout(() => {
//           fetchQuizData();
//         }, 100);
//       } else if (key === "attendance" && !attendanceDataLoaded) {
//         setTimeout(() => {
//           fetchAttendanceData();
//         }, 100);
//       } else if (key === "applied-jobs" && !appliedJobsDataLoaded) {
//         setTimeout(() => {
//           fetchAppliedJobsData();
//         }, 100);
//       }
//     }, 500);
//   };

//   const handleInputChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSave = async () => {
//     try {
//       await onUpdate(formData);
//       setEditMode(false);
//       toast.success("Student updated successfully!");
//       handleCloseAllModals();
//     } catch (error) {
//       toast.error("Failed to update student: " + error.message);
//     }
//   };

//   const handleCancel = () => {
//     setFormData(originalFormData);
//     setEditMode(false);
//     handleCloseAllModals();
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   // NEW FUNCTION: Handle Download Resume with Job Selection
//   const handleDownloadCVClick = () => {
//     if (!student.cvUpload) {
//       toast.error("No resume available for download");
//       return;
//     }

//     // Check if student has applied for multiple jobs
//     if (appliedJobsData && appliedJobsData.length > 1) {
//       // Show modal to select which job profile resume to download
//       const options = appliedJobsData.map((job) => ({
//         id: job.id || job.jobProfileId,
//         jobName: job.jobName,
//         organizationName: job.organizationName,
//         salary: job.salary,
//         jobProfileId: job.jobProfileId,
//       }));

//       setResumeDownloadOptions(options);
//       setShowDownloadResumeModal(true);
//     } else if (appliedJobsData && appliedJobsData.length === 1) {
//       // If only one job, download directly
//       performCVDownload();
//     } else {
//       // No applied jobs, download directly
//       performCVDownload();
//     }
//   };

//   // Function to perform the actual CV download
//   const performCVDownload = (jobInfo = null) => {
//     if (student.cvUpload) {
//       const link = document.createElement("a");
//       const cvUrl = `${student.cvUpload}`;

//       link.href = cvUrl;

//       // Create filename based on student name and job info
//       let filename = `${student.studentName}_Resume`;
//       if (jobInfo && jobInfo.jobName) {
//         filename += `_${jobInfo.jobName}`;
//       }
//       filename += ".pdf";

//       link.download = filename;
//       link.target = "_blank";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       toast.success("Resume download started!");
//       setShowDownloadResumeModal(false);
//       setResumeDownloadOptions([]);
//     } else {
//       toast.error("No resume available for download");
//     }
//   };

//   const handleCopyStudent = () => {
//     navigator.clipboard.writeText(student.studentName);
//     toast.success("Student name copied to clipboard!");
//   };

//   const handleShareStudent = () => {
//     toast.info("Share functionality to be implemented");
//   };

//   const handleEditStudent = () => {
//     setActiveTab("edit");
//     setEditMode(true);
//   };

//   const handleEmail = () => {
//     if (student.studentEmail) {
//       window.location.href = `mailto:${student.studentEmail}`;
//     }
//   };

//   const handleCall = () => {
//     if (student.studentPhoneNumber) {
//       window.location.href = `tel:${student.studentPhoneNumber}`;
//     }
//   };

//   const tabs = [
//     { key: "details", label: "Details", icon: User },
//     // { key: "edit", label: "Edit Student", icon: Edit3 },
//     { key: "quiz", label: "Quiz Performance", icon: Trophy },
//     { key: "attendance", label: "Attendance", icon: UserCheck },
//     { key: "applied-jobs", label: "Applied Jobs", icon: Briefcase },
//   ];

//   const visibleTabs = tabs.slice(0, 6);
//   const hiddenTabs = tabs.slice(6);

//   const TabIcon = ({ icon: Icon, active }) => (
//     <Icon
//       size={16}
//       color={active ? "#ea580c" : "#6c757d"}
//       style={{ marginRight: "6px" }}
//     />
//   );

//   const renderTabContent = () => {
//     if (loadingTab) {
//       return (
//         <div
//           style={{
//             textAlign: "center",
//             padding: "60px 20px",
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "300px",
//           }}
//         >
//           <Spinner
//             animation="border"
//             style={{
//               color: "#f97316",
//               width: "2.5rem",
//               height: "2.5rem",
//               borderWidth: "3px",
//             }}
//           />
//           <p style={{ marginTop: "16px", color: "#6c757d" }}>Loading...</p>
//         </div>
//       );
//     }

//     switch (activeTab) {
//       case "details":
//         return renderDetailsTab();
//       case "edit":
//         return renderEditTab();
//       case "quiz":
//         return renderQuizTab();
//       case "attendance":
//         return renderAttendanceTab();
//       case "applied-jobs":
//         return renderAppliedJobsTab();
//       default:
//         return renderDetailsTab();
//     }
//   };

//   const renderEditTab = () => (
//     <div className="edit-student-content">
//       <Form>
//         <Row>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formStudentName">
//               <Form.Label>Student Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.studentName}
//                 onChange={(e) =>
//                   handleInputChange("studentName", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formStudentEmail">
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 value={formData.studentEmail}
//                 onChange={(e) =>
//                   handleInputChange("studentEmail", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formDepartment">
//               <Form.Label>Department</Form.Label>
//               <AsyncSelectDropdown
//                 options={getDepartmentOptions()}
//                 value={getSelectedDepartmentOption()}
//                 onChange={(selectedOption) =>
//                   handleInputChange(
//                     "department",
//                     selectedOption ? selectedOption.value : "",
//                   )
//                 }
//                 placeholder="Select the Department"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formStudentPhoneNumber">
//               <Form.Label>Phone</Form.Label>
//               <Form.Control
//                 type="tel"
//                 value={formData.studentPhoneNumber}
//                 onChange={(e) =>
//                   handleInputChange("studentPhoneNumber", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formSelectBranch">
//               <Form.Label>Branch</Form.Label>
//               <AsyncSelectDropdown
//                 options={getBranchOptions()}
//                 value={getSelectedBranchOption()}
//                 onChange={(selectedOption) =>
//                   handleInputChange(
//                     "selectBranch",
//                     selectedOption ? selectedOption.value : "",
//                   )
//                 }
//                 placeholder="Select the Branch"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formWorkExperience">
//               <Form.Label>Experience</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.workExperience}
//                 onChange={(e) =>
//                   handleInputChange("workExperience", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={12}>
//             <Form.Group className="mb-3" controlId="formTechnologiesLearned">
//               <Form.Label>Technologies</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.technologiesLearned}
//                 onChange={(e) =>
//                   handleInputChange("technologiesLearned", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={4}>
//             <Form.Group className="mb-3" controlId="formTenthPercentageAndYear">
//               <Form.Label>10th Grade</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.tenthPercentageAndYear}
//                 onChange={(e) =>
//                   handleInputChange("tenthPercentageAndYear", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//           <Col md={4}>
//             <Form.Group
//               className="mb-3"
//               controlId="formTwelfthPercentageAndYear"
//             >
//               <Form.Label>12th Grade</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.twelfthPercentageAndYear}
//                 onChange={(e) =>
//                   handleInputChange("twelfthPercentageAndYear", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//           <Col md={4}>
//             <Form.Group
//               className="mb-3"
//               controlId="formGraduationPercentageAndYear"
//             >
//               <Form.Label>Graduation</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.graduationPercentageAndYear}
//                 onChange={(e) =>
//                   handleInputChange(
//                     "graduationPercentageAndYear",
//                     e.target.value,
//                   )
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={6}>
//             <Form.Group className="mb-3" controlId="formOneTimePlacementFee">
//               <Form.Label>Placement Fee</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.oneTimePlacementFee}
//                 onChange={(e) =>
//                   handleInputChange("oneTimePlacementFee", e.target.value)
//                 }
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group
//               className="mb-3"
//               controlId="formPostGraduationPercentageAndYear"
//             >
//               <Form.Label>Post Graduation</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={formData.postGraduationPercentageAndYear}
//                 onChange={(e) =>
//                   handleInputChange(
//                     "postGraduationPercentageAndYear",
//                     e.target.value,
//                   )
//                 }
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={4}>
//             <Form.Group className="mb-3" controlId="formCourse1">
//               <Form.Label>Course 1</Form.Label>
//               <AsyncSelectDropdown
//                 options={getCourseOptions([formData.course2, formData.course3])}
//                 value={getSelectedCourseOption("course1")}
//                 onChange={(selectedOption) =>
//                   handleInputChange(
//                     "course1",
//                     selectedOption ? selectedOption.value : "",
//                   )
//                 }
//                 placeholder="Select the course"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={4}>
//             <Form.Group className="mb-3" controlId="formCourse2">
//               <Form.Label>Course 2</Form.Label>
//               <AsyncSelectDropdown
//                 options={getCourseOptions([formData.course1, formData.course3])}
//                 value={getSelectedCourseOption("course2")}
//                 onChange={(selectedOption) =>
//                   handleInputChange(
//                     "course2",
//                     selectedOption ? selectedOption.value : "",
//                   )
//                 }
//                 placeholder="Select the course"
//               />
//             </Form.Group>
//           </Col>
//           <Col md={4}>
//             <Form.Group className="mb-3" controlId="formCourse3">
//               <Form.Label>Course 3</Form.Label>
//               <AsyncSelectDropdown
//                 options={getCourseOptions([formData.course1, formData.course2])}
//                 value={getSelectedCourseOption("course3")}
//                 onChange={(selectedOption) =>
//                   handleInputChange(
//                     "course3",
//                     selectedOption ? selectedOption.value : "",
//                   )
//                 }
//                 placeholder="Select the course"
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
//           <Button variant="success" onClick={handleSave} className="px-4">
//             Save Changes
//           </Button>
//           <Button variant="secondary" onClick={handleCancel} className="px-4">
//             Cancel
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );

//   const renderDetailsTab = () => (
//     <div className="student-summary-content">
//       {error && (
//         <Alert
//           variant="danger"
//           className="mb-4"
//           dismissible
//           onClose={() => setError(null)}
//         >
//           <AlertCircle size={16} className="me-2" />
//           {error}
//         </Alert>
//       )}

//       <Row className="student-header-row">
//         <Col md={2}>
//           <span className="field-label">Student Name</span>
//         </Col>
//         <Col md={3}>
//           <span className="field-label">Email</span>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">Department</span>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">Phone</span>
//         </Col>
//         <Col md={3}>
//           <span className="field-label">Branch</span>
//         </Col>
//       </Row>

//       <Row className="student-data-row">
//         <Col md={2}>
//           <div className="field-value">
//             {student.studentName || 
//              (Array.isArray(student.studentId) ? student.studentId[0]?.name : "N/A")}
//           </div>
//         </Col>
//         <Col md={3}>
//           <div
//             className="field-value"
//             style={{
//               wordBreak: "break-all",
//               whiteSpace: "normal",
//               overflowWrap: "anywhere",
//             }}
//           >
//             {student.studentEmail || 
//              (Array.isArray(student.studentId) ? student.studentId[0]?.email : "N/A")}
//           </div>
//         </Col>
//         <Col md={2}>
//           <div className="field-value">
//             {student.departmentName ||
//               getDepartmentNameById(student.department)}
//           </div>
//         </Col>
//         <Col md={2}>
//           <div className="field-value">
//             {student.studentPhoneNumber || 
//              (Array.isArray(student.studentId) ? student.studentId[0]?.phone : "N/A")}
//           </div>
//         </Col>
//         <Col md={3}>
//           <div className="field-value">
//             {student.branchName || getBranchNameById(student.selectBranch)}
//           </div>
//         </Col>
//         <Col md={2}>
//           <div className="field-value">
//             {student.workExperience || "No experience"}
//           </div>
//         </Col>
//       </Row>

//       <Row className="student-additional-row mt-3">
//         <Col md={2}>
//           <span className="field-label">Technologies</span>
//           <div className="field-value">
//             {student.technologiesLearned || "Not specified"}
//           </div>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">10th Grade</span>
//           <div className="field-value">
//             {student.tenthPercentageAndYear || "Not specified"}
//           </div>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">12th Grade</span>
//           <div className="field-value">
//             {student.twelfthPercentageAndYear || "Not specified"}
//           </div>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">Graduation</span>
//           <div className="field-value">
//             {student.graduationPercentageAndYear || "Not specified"}
//           </div>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">Placement Fee</span>
//           <div className="field-value">
//             {student.oneTimePlacementFee || "Not specified"}
//           </div>
//         </Col>
//         <Col md={2}>
//           <span className="field-label">Applied Date</span>
//           <div className="field-value">
//             {student.createdAt
//               ? new Date(student.createdAt).toLocaleDateString()
//               : "N/A"}
//           </div>
//         </Col>
//       </Row>

//       <div className="courses-section">
//         <h6>Enrolled Courses</h6>
//         <div className="courses-details">
//           {student.course1 && (
//             <p>
//               <strong>Course 1:</strong>{" "}
//               {getCourseNameByCourseModuleId(student.course1)}
//             </p>
//           )}
//           {student.course2 && (
//             <p>
//               <strong>Course 2:</strong>{" "}
//               {getCourseNameByCourseModuleId(student.course2)}
//             </p>
//           )}
//           {student.course3 && (
//             <p>
//               <strong>Course 3:</strong>{" "}
//               {getCourseNameByCourseModuleId(student.course3)}
//             </p>
//           )}
//           {!student.course1 && !student.course2 && !student.course3 && (
//             <p className="text-muted">No courses enrolled</p>
//           )}
//         </div>
//       </div>

//       {student.id && (
//         <CommentsSection
//           entityId={student.id}
//           type="job-applied-students"
//           title={`Discussion about ${student.studentName}`}
//           users={users}
//           onError={handleCommentsError}
//           showCollapse={true}
//           defaultExpanded={true}
//           maxHeight="500px"
//           className="student-comments-section"
//         />
//       )}
//     </div>
//   );

//   const renderQuizTab = () => (
//     <div className="quiz-performance">
//       <div className="d-flex align-items-center mb-3">
//         <Trophy size={20} className="me-2 text-warning" />
//         <h5 className="mb-0">Quiz Performance</h5>
//       </div>

//       {loadingQuiz ? (
//         <div className="text-center py-4">
//           <Spinner animation="border" variant="primary" />
//           <p className="mt-2">Loading quiz data...</p>
//         </div>
//       ) : quizData.length > 0 ? (
//         <div className="table-responsive">
//           <table className="table table-striped table-bordered table-hover table-sm">
//             <thead className="table-primary">
//               <tr>
//                 <th>Quiz Name</th>
//                 <th>Batch</th>
//                 <th>Score</th>
//                 <th>Result</th>
//                 <th>Time Taken</th>
//                 <th>Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {quizData.slice(0, 5).map((quiz, index) => (
//                 <tr key={index}>
//                   <td className="fw-semibold">{quiz.quizName}</td>
//                   <td>
//                     <span className="badge bg-info text-white">
//                       {quiz.batchName}
//                     </span>
//                   </td>
//                   <td>
//                     <strong className="text-primary">
//                       {quiz.score || "N/A"}
//                       {quiz.totalMarks ? `/${quiz.totalMarks}` : ""}
//                     </strong>
//                   </td>
//                   <td>
//                     {quiz.result === "Pass" ? (
//                       <span className="badge bg-success">Pass</span>
//                     ) : (
//                       <span className="badge bg-danger">Fail</span>
//                     )}
//                   </td>
//                   <td className="text-muted">{quiz.timeConsumed || "N/A"}</td>
//                   <td className="text-muted">
//                     {quiz.createdAt
//                       ? new Date(quiz.createdAt).toLocaleDateString()
//                       : "N/A"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {quizData.length > 5 && (
//             <small className="text-muted">
//               Showing 5 of {quizData.length} quiz attempts
//             </small>
//           )}
//         </div>
//       ) : (
//         <div className="alert alert-info">
//           <Trophy size={16} className="me-2" />
//           No quiz attempts found for this student.
//         </div>
//       )}
//     </div>
//   );

//   const renderAttendanceTab = () => (
//     <div className="attendance-summary">
//       <div className="d-flex align-items-center mb-3">
//         <UserCheck size={20} className="me-2 text-success" />
//         <h5 className="mb-0">Attendance Summary</h5>
//       </div>

//       {loadingAttendance ? (
//         <div className="text-center py-4">
//           <Spinner animation="border" variant="primary" />
//           <p className="mt-2">Loading attendance data...</p>
//         </div>
//       ) : attendanceData.totalLectures > 0 ? (
//         <>
//           <Row className="mb-3">
//             <Col md={3} xs={6} className="mb-2">
//               <div className="text-center p-3 bg-light rounded shadow-sm">
//                 <h5 className="mb-1 text-primary">
//                   {attendanceData.totalLectures}
//                 </h5>
//                 <small className="text-muted fw-semibold">Total Classes</small>
//               </div>
//             </Col>
//             <Col md={3} xs={6} className="mb-2">
//               <div className="text-center p-3 bg-light rounded shadow-sm">
//                 <h5 className="mb-1 text-success">
//                   {attendanceData.totalPresent}
//                 </h5>
//                 <small className="text-muted fw-semibold">Present</small>
//               </div>
//             </Col>
//             <Col md={3} xs={6} className="mb-2">
//               <div className="text-center p-3 bg-light rounded shadow-sm">
//                 <h5 className="mb-1 text-danger">
//                   {attendanceData.totalAbsent}
//                 </h5>
//                 <small className="text-muted fw-semibold">Absent</small>
//               </div>
//             </Col>
//             <Col md={3} xs={6} className="mb-2">
//               <div className="text-center p-3 bg-light rounded shadow-sm">
//                 <h5 className="mb-1 text-info">
//                   {attendanceData.attendancePercentage}%
//                 </h5>
//                 <small className="text-muted fw-semibold">
//                   Overall Attendance
//                 </small>
//               </div>
//             </Col>
//           </Row>

//           {attendanceData.batchWiseData &&
//             attendanceData.batchWiseData.length > 0 && (
//               <div className="batch-wise-attendance mt-4">
//                 <h6 className="mb-3">
//                   <i className="fas fa-chart-bar me-2"></i>
//                   Batch-wise Attendance Details
//                 </h6>

//                 {attendanceData.batchWiseData.map((batchData, index) => {
//                   // Find the course name for this batch
//                   const batch = batches.find((b) => b.id === batchData.batchId);
//                   const course =
//                     batch && courses
//                       ? courses.find((c) => c.id === batch.courseId)
//                       : null;
//                   const courseName = course
//                     ? course.courseName || course.name
//                     : null;

//                   return (
//                     <div
//                       key={index}
//                       className="batch-card mb-3 p-3 border rounded"
//                     >
//                       <div className="d-flex justify-content-between align-items-center mb-2">
//                         <h6 className="mb-0 text-primary">
//                           <i className="fas fa-users me-2"></i>
//                           {batchData.batchName}
//                           {courseName && (
//                             <span
//                               style={{
//                                 fontWeight: "normal",
//                                 fontSize: "0.9em",
//                                 marginLeft: "8px",
//                               }}
//                             >
//                               ({courseName})
//                             </span>
//                           )}
//                         </h6>
//                       </div>

//                       <Row className="mb-2">
//                         <Col xs={3}>
//                           <div className="text-center">
//                             <div className="fw-bold text-primary">
//                               {batchData.totalLectures}
//                             </div>
//                             <small className="text-muted">Total</small>
//                           </div>
//                         </Col>
//                         <Col xs={3}>
//                           <div className="text-center">
//                             <div className="fw-bold text-success">
//                               {batchData.totalPresent}
//                             </div>
//                             <small className="text-muted">Present</small>
//                           </div>
//                         </Col>
//                         <Col xs={3}>
//                           <div className="text-center">
//                             <div className="fw-bold text-danger">
//                               {batchData.totalAbsent}
//                             </div>
//                             <small className="text-muted">Absent</small>
//                           </div>
//                         </Col>
//                         <Col xs={3}>
//                           <div className="text-center">
//                             <div className="fw-bold text-info">
//                               {batchData.attendancePercentage}%
//                             </div>
//                             <small className="text-muted">Rate</small>
//                           </div>
//                         </Col>
//                       </Row>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//         </>
//       ) : (
//         <div className="alert alert-info">
//           <UserCheck size={16} className="me-2" />
//           No attendance records found for this student.
//         </div>
//       )}
//     </div>
//   );

//   const renderAppliedJobsTab = () => {
//     const filteredJobs = getFilteredAppliedJobs();

//     return (
//       <div className="tab-pane-content">
//         {loadingAppliedJobs ? (
//           <div className="text-center py-4">
//             <Spinner animation="border" />
//             <p className="mt-2">Loading applied jobs data...</p>
//           </div>
//         ) : (
//           <>
//             {appliedJobsData.length > 0 ? (
//               <>
//                 <div className="mb-4 p-3 bg-light rounded">
//                   <h6 className="mb-3">
//                     <Briefcase size={18} className="me-2" />
//                     Filter Applied Jobs
//                   </h6>
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label>Filter by Job Title</Form.Label>
//                         <Form.Control
//                           type="text"
//                           placeholder="Search job titles..."
//                           value={jobTitleFilter}
//                           onChange={(e) => setJobTitleFilter(e.target.value)}
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label>Filter by Company</Form.Label>
//                         <Form.Control
//                           type="text"
//                           placeholder="Search companies..."
//                           value={companyFilter}
//                           onChange={(e) => setCompanyFilter(e.target.value)}
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                   {(jobTitleFilter || companyFilter) && (
//                     <div className="d-flex justify-content-between align-items-center">
//                       <small className="text-muted">
//                         Showing {filteredJobs.length} of{" "}
//                         {appliedJobsData.length} jobs
//                       </small>
//                       <Button
//                         variant="link"
//                         size="sm"
//                         onClick={() => {
//                           setJobTitleFilter("");
//                           setCompanyFilter("");
//                         }}
//                         className="p-0"
//                       >
//                         Clear Filters
//                       </Button>
//                     </div>
//                   )}
//                 </div>

//                 <div className="mb-3">
//                   <h6>
//                     Total Applied Jobs:{" "}
//                     <span className="badge bg-primary">
//                       {appliedJobsData.length}
//                     </span>
//                     {filteredJobs.length !== appliedJobsData.length && (
//                       <span className="ms-2">
//                         Filtered:{" "}
//                         <span className="badge bg-secondary">
//                           {filteredJobs.length}
//                         </span>
//                       </span>
//                     )}
//                   </h6>
//                 </div>

//                 {filteredJobs.length > 0 ? (
//                   <div className="table-responsive">
//                     <table className="table table-striped">
//                       <thead>
//                         <tr>
//                           <th>Job Title</th>
//                           <th>Company</th>
//                           <th>Location</th>
//                           <th>Salary</th>
//                           <th>Status</th>
//                           <th>Applied Date</th>
//                           <th>Department</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {filteredJobs.map((job, index) => (
//                           <tr key={index}>
//                             <td>
//                               <Button
//                                 variant="link"
//                                 className="p-0 text-start"
//                                 style={{ textDecoration: "none" }}
//                                 onClick={() => handleJobClickForPlacement(job)}
//                               >
//                                 <strong className="text-primary">
//                                   {job.jobName}
//                                 </strong>
//                               </Button>
//                             </td>
//                             <td>
//                               <span
//                                 style={{
//                                   color: job.organizationId
//                                     ? "#0d6efd"
//                                     : "#212529",
//                                   cursor: job.organizationId
//                                     ? "pointer"
//                                     : "default",
//                                   fontWeight: job.organizationId
//                                     ? "500"
//                                     : "normal",
//                                 }}
//                                 onClick={() => job.organizationId && handleViewOrganization(job.organizationId)}
//                               >
//                                 {job.organizationName}
//                               </span>
//                             </td>
//                             <td>
//                               <span className="text-muted">
//                                 📍 {job.jobLocation}
//                               </span>
//                             </td>
//                             <td>
//                               <span className="text-success font-weight-bold">
//                                 {job.salary}
//                               </span>
//                             </td>
//                             <td>
//                               <span
//                                 className={`badge ${
//                                   job.status === "active"
//                                     ? "bg-success"
//                                     : job.status === "inactive"
//                                       ? "bg-secondary"
//                                       : "bg-warning"
//                                 }`}
//                               >
//                                 {job.status}
//                               </span>
//                             </td>
//                             <td>
//                               {job.jobPostedDate
//                                 ? new Date(
//                                     job.jobPostedDate,
//                                   ).toLocaleDateString()
//                                 : "N/A"}
//                             </td>
//                             <td>
//                               <span className="badge bg-info">
//                                 {job.departmentName}
//                               </span>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 ) : (
//                   <div className="alert alert-info">
//                     <Briefcase size={16} className="me-2" />
//                     No jobs found matching your filter criteria.
//                   </div>
//                 )}
//               </>
//             ) : (
//               <div className="text-center py-4">
//                 <div className="mb-3">
//                   <Briefcase size={48} className="text-muted" />
//                 </div>
//                 <h6 className="text-muted">No Applied Jobs</h6>
//                 <p className="text-muted">
//                   This student hasn't applied for any jobs yet.
//                 </p>
//               </div>
//             )}
//           </>
//         )}

//         <AppliedStudentsView
//           jobProfile={selectedJobProfile}
//           isVisible={showAppliedStudentsModal}
//           onClose={() => {
//             setShowAppliedStudentsModal(false);
//             setSelectedJobProfile(null);
//           }}
//           onCloseAll={handleCloseAllModals}
//           users={users}
//           contacts={contacts}
//           courses={courses}
//           departments={departments}
//           branches={branches}
//           batches={batches}
//           jobProfiles={jobProfiles}
//         />
//       </div>
//     );
//   };

//   const renderMainContent = () => {
//     if (activeTab === "applied-jobs") {
//       // Full width for applied jobs tab
//       return renderAppliedJobsTab();
//     }

//     // Two-column layout for other tabs
//     return (
//       <Row className="h-100" style={{ margin: 0 }}>
//         {/* Left Column: Details/Quiz/Attendance + Activity */}
//         <Col
//           md={9}
//           style={{
//             borderRight: "1px solid #e9ecef",
//             paddingRight: "20px",
//             height: "calc(90vh - 200px)",
//             maxHeight: "700px",
//             overflowY: "auto",
//           }}
//         >
//           <div className="tab-content-left">{renderTabContent()}</div>
//         </Col>

//         {/* Right Column: Jobs */}
//         <Col
//           md={3}
//           style={{
//             paddingLeft: "20px",
//             height: "calc(90vh - 200px)",
//             maxHeight: "700px",
//             overflowY: "auto",
//             overflowX: "hidden",
//           }}
//         >
//           <div className="jobs-sidebar">
//             <h6
//               className="mb-3"
//               style={{ fontWeight: "600", fontSize: "16px" }}
//             >
//               <Briefcase
//                 size={18}
//                 className="me-2"
//                 style={{ display: "inline" }}
//               />
//               Jobs
//             </h6>
//             {appliedJobsData.length > 0 ? (
//               <div>
//                 <div className="mb-3">
//                   <small className="text-muted">
//                     Total Applied:{" "}
//                     <span className="badge bg-primary">
//                       {appliedJobsData.length}
//                     </span>
//                   </small>
//                 </div>
//                 <div
//                   className="jobs-list"
//                   style={{ maxHeight: "500px", overflowY: "auto" }}
//                 >
//                   {appliedJobsData.slice(0, 5).map((job, index) => (
//                     <div
//                       key={index}
//                       className="job-card mb-3 p-3"
//                       style={{
//                         border: "1px solid #e9ecef",
//                         borderRadius: "6px",
//                         backgroundColor: "#f8f9fa",
//                         cursor: "pointer",
//                         transition: "all 0.2s",
//                       }}
//                       onClick={() => handleJobClickForPlacement(job)}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.backgroundColor = "#e9ecef";
//                         e.currentTarget.style.boxShadow =
//                           "0 2px 4px rgba(0,0,0,0.1)";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.backgroundColor = "#f8f9fa";
//                         e.currentTarget.style.boxShadow = "none";
//                       }}
//                     >
//                       <div
//                         className="job-title"
//                         style={{ fontWeight: "600", marginBottom: "4px" }}
//                       >
//                         {job.jobName}
//                       </div>
//                       <div
//                         className="job-company"
//                         style={{
//                           fontSize: "12px",
//                           color: "#6c757d",
//                           marginBottom: "4px",
//                         }}
//                       >
//                         {job.organizationName}
//                       </div>
//                       <div
//                         className="job-location"
//                         style={{ fontSize: "12px", color: "#6c757d" }}
//                       >
//                         📍 {job.jobLocation}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 {appliedJobsData.length > 5 && (
//                   <Button
//                     variant="link"
//                     size="sm"
//                     onClick={() => handleTabSelect("applied-jobs")}
//                     className="mt-2"
//                   >
//                     View All Jobs ({appliedJobsData.length})
//                   </Button>
//                 )}
//               </div>
//             ) : (
//               <div className="text-center py-4" style={{ color: "#6c757d" }}>
//                 <Briefcase
//                   size={32}
//                   className="mb-2"
//                   style={{ opacity: 0.5 }}
//                 />
//                 <p style={{ fontSize: "14px" }}>No Related Placement</p>
//               </div>
//             )}
//           </div>
//         </Col>
//       </Row>
//     );
//   };

//   if (!isVisible || !student) return null;

//   return (
//     <>
//       {/* MAIN STUDENT MODAL */}
//       <Modal
//         show={isVisible}
//         onHide={handleCloseAllModals}
//         size="xl"
//         centered
//         className="student-modal"
//         backdrop="static"
//         dialogClassName="fixed-size-modal"
//       >
//         <div
//           className="modal-container"
//           style={{
//             padding: "20px",
//             minHeight: "600px",
//             maxHeight: "90vh",
//             display: "flex",
//             flexDirection: "column",
//           }}
//         >
//           <Modal.Header
//             className="student-modal-header"
//             style={{ flexShrink: 0 }}
//           >
//             <div className="header-content">
//               <div className="left-section">
//                 <Button
//                   variant="link"
//                   onClick={handleCloseAllModals}
//                   className="close-btn"
//                 >
//                   <ArrowLeft size={20} />
//                 </Button>
//                 <div className="student-info">
//                   <div className="student-avatar">
//                     {student.studentName?.substring(0, 2)?.toUpperCase() ||
//                       "ST"}
//                   </div>
//                   <div>
//                     <div className="student-details">
//                       <h5 className="student-name">{student.studentName}</h5>
//                       <div className="name-icons">
//                         <Button
//                           variant="link"
//                           className="name-icon-btn"
//                           onClick={handleEditStudent}
//                         >
//                           <Edit3 size={16} />
//                         </Button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="action-buttons">
//                 <Button
//                   variant="link"
//                   onClick={handleCloseAllModals}
//                   className="p-2 ms-2"
//                   style={{
//                     color: "#6c757d",
//                     textDecoration: "none",
//                     border: "none",
//                     background: "transparent",
//                   }}
//                   title="Close"
//                 >
//                   <X size={20} />
//                 </Button>
//               </div>
//             </div>
//           </Modal.Header>

//           <div className="tabs-container" style={{ flexShrink: 0 }}>
//             <div className="d-flex align-items-center">
//               <Nav variant="tabs" className="custom-tabs flex-grow-1">
//                 {visibleTabs.map((tab) => (
//                   <Nav.Item key={tab.key}>
//                     <Nav.Link
//                       active={activeTab === tab.key}
//                       onClick={() => handleTabSelect(tab.key)}
//                       className="custom-tab-link"
//                     >
//                       <TabIcon icon={tab.icon} active={activeTab === tab.key} />
//                       {tab.label}
//                     </Nav.Link>
//                   </Nav.Item>
//                 ))}

//                 {hiddenTabs.length > 0 && (
//                   <Nav.Item className="more-tabs-item">
//                     <Dropdown>
//                       <Dropdown.Toggle as={Nav.Link} className="more-tabs-link">
//                         <span className="tab-count">{hiddenTabs.length}</span>{" "}
//                         More
//                         <ChevronDown size={12} className="more-dropdown-icon" />
//                       </Dropdown.Toggle>
//                       <Dropdown.Menu>
//                         {hiddenTabs.map((tab) => (
//                           <Dropdown.Item
//                             key={tab.key}
//                             onClick={() => handleTabSelect(tab.key)}
//                             className={activeTab === tab.key ? "active" : ""}
//                           >
//                             <TabIcon
//                               icon={tab.icon}
//                               active={activeTab === tab.key}
//                             />
//                             {tab.label}
//                           </Dropdown.Item>
//                         ))}
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </Nav.Item>
//                 )}

//                 {student.cvUpload && (
//                   <Nav.Item className="download-nav-item">
//                     <Button
//                       variant="outline-primary"
//                       size="sm"
//                       onClick={handleDownloadCVClick}
//                       className="download-resume-tab-btn"
//                     >
//                       <Download size={16} className="me-1" />
//                       Download Resume
//                     </Button>
//                   </Nav.Item>
//                 )}
//               </Nav>
//             </div>
//           </div>

//           <Modal.Body
//             className="student-modal-body"
//             style={{
//               flex: 1,
//               overflowY: "hidden",
//               minHeight: 0,
//               padding: "20px",
//             }}
//           >
//             <div
//               className="full-width-content"
//               style={{
//                 height: "100%",
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               {renderMainContent()}
//             </div>
//           </Modal.Body>
//         </div>

//         <style>{`
//           .fixed-size-modal {
//             max-width: 95vw !important;
//             width: 95vw !important;
//           }

//           .fixed-size-modal .modal-content {
//             height: 95vh !important;
//             max-height: 95vh !important;
//             display: flex !important;
//             flex-direction: column !important;
//           }

//           .student-comments-section {
//             border: 2px solid #c3e6cb;
//             background: linear-gradient(135deg, #f0fff0 0%, #e6ffe6 100%);
//             margin-top: 30px;
//           }

//           .debug-info {
//             border-left: 3px solid #28a745;
//           }

//           .courses-section {
//             margin: 30px 0;
//             padding: 20px;
//             background: #f8f9fa;
//             border-radius: 8px;
//           }

//           .courses-section h6 {
//             color: #495057;
//             margin-bottom: 15px;
//             font-weight: 600;
//           }

//           .courses-details {
//             background: white;
//             padding: 20px;
//             border-radius: 6px;
//             border: 1px solid #e9ecef;
//             margin-bottom: 15px;
//             line-height: 1.6;
//           }

//           /* Dark backdrop for Download Resume Modal */
// .download-resume-modal-backdrop {
//   background-color: rgba(0, 0, 0, 0.85) !important;
//   opacity: 1 !important;
// }

// .download-resume-modal-dialog {
//   z-index: 1060 !important;
// }

// .download-resume-modal-dialog .modal-content {
//   background-color: #ffffff;
//   border-radius: 12px;
//   box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
//   border: none;
// }

// .job-option-item:hover {
//   box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
//   transform: translateY(-2px);
// }

//         `}</style>
//       </Modal>

//       {/* NEW MODAL FOR SELECTING WHICH JOB RESUME TO DOWNLOAD - WITH DARK BACKDROP */}
//       <Modal
//         show={showDownloadResumeModal}
//         onHide={() => {
//           setShowDownloadResumeModal(false);
//           setResumeDownloadOptions([]);
//         }}
//         centered
//         backdrop="static"
//         className="download-resume-modal-dialog download-resume-modal-backdrop"
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             <span
//               style={{ fontSize: "1.2em", fontWeight: "500", color: "#333" }}
//             >
//               Select Job Profile for Resume Download
//             </span>
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ padding: "30px", backgroundColor: "#f9f9f9" }}>
//           <p
//             className="text-muted mb-4"
//             style={{ fontSize: "0.95em", color: "#666" }}
//           >
//             This student has applied for {resumeDownloadOptions.length} job(s).
//             Click download button on the job to download resume:
//           </p>

//           <div style={{ maxHeight: "500px", overflowY: "auto" }}>
//             {resumeDownloadOptions.map((option, index) => (
//               <div
//                 key={index}
//                 style={{
//                   backgroundColor: "#ffffff",
//                   border: "1px solid #e0e0e0",
//                   borderRadius: "8px",
//                   padding: "20px",
//                   marginBottom: "16px",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   transition: "all 0.2s ease",
//                   cursor: "pointer",
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.boxShadow =
//                     "0 2px 8px rgba(0, 0, 0, 0.08)";
//                   e.currentTarget.style.borderColor = "#d0d0d0";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.boxShadow = "none";
//                   e.currentTarget.style.borderColor = "#e0e0e0";
//                 }}
//               >
//                 <div>
//                   <h6
//                     style={{
//                       marginBottom: "8px",
//                       fontSize: "1em",
//                       fontWeight: "600",
//                       color: "#1a1a1a",
//                     }}
//                   >
//                     {option.jobName}
//                   </h6>
//                   <p
//                     style={{
//                       marginBottom: "4px",
//                       fontSize: "0.9em",
//                       color: "#777",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "6px",
//                     }}
//                   >
//                     {option.organizationName}
//                   </p>
//                 </div>
//                 <Button
//                   variant="danger"
//                   style={{
//                     backgroundColor: "#ff5a7e",
//                     border: "none",
//                     borderRadius: "6px",
//                     padding: "8px 20px",
//                     fontSize: "0.9em",
//                     fontWeight: "600",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "6px",
//                     whiteSpace: "nowrap",
//                     flexShrink: 0,
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     performCVDownload(option);
//                   }}
//                 >
//                   <Download size={16} />
//                   Download
//                 </Button>
//               </div>
//             ))}
//           </div>
//         </Modal.Body>
//         <Modal.Footer
//           style={{ borderTop: "1px solid #e0e0e0", padding: "15px 30px" }}
//         >
//           <Button
//             variant="secondary"
//             style={{
//               backgroundColor: "#2d3e50",
//               border: "none",
//               borderRadius: "6px",
//               padding: "8px 24px",
//               color: "white",
//               fontWeight: "600",
//             }}
//             onClick={() => {
//               setShowDownloadResumeModal(false);
//               setResumeDownloadOptions([]);
//             }}
//           >
//             Cancel
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Placement Popup Modal */}
//       <PlacementPopupView
//         show={showPlacementPopup}
//         onHide={() => {
//           setShowPlacementPopup(false);
//           setSelectedPlacementForPopup(null);
//           setDefaultActiveTabForPlacement("summary");
//         }}
//         placement={selectedPlacementForPopup}
//         onUpdatePlacement={handleUpdatePlacementFromPopup}
//         defaultTab={defaultActiveTabForPlacement}
//         departments={departments}
//         branches={branches}
//       />

//       {/* Organization Popup Modal */}
//       {selectedOrganizationForPopup && (
//         <OrganizationPopupView
//           show={showOrganizationPopup}
//           onHide={handleCloseOrganizationPopup}
//           organization={selectedOrganizationForPopup}
//           onUpdateOrganization={handleUpdateOrganization}
//           defaultActiveTab={defaultActiveOrgTab}
//         />
//       )}
//     </>
//   );
// };

// export default StudentPopupView;


import { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Nav,
  Dropdown,
  Row,
  Col,
  Spinner,
  Form,
  Alert,
} from "react-bootstrap";
import {
  ArrowLeft,
  User,
  FileText,
  Star,
  Phone,
  Mail,
  ChevronDown,
  Copy,
  Share2,
  Edit3,
  Trophy,
  UserCheck,
  Download,
  Briefcase,
  X,
  AlertCircle,
} from "lucide-react";
import { toast } from "react-toastify";
import AsyncSelectDropdown from "../../../components/common/FormFields/AysncSelectDropdown.jsx";
import CommentsSection from "../../commentSection/CommentSection.jsx";
import { getResumeDownloadUrl } from "../../../../services/resumeUrl";

// Correct imports exactly matching admin dashboard
import { getStudentTabWiseInfo } from "../../../../services/StudentService";
import { getBatchQuizHistories } from "../../../../services/BatchQuizHistoryService.js";
import { getQuizzes } from "../../../../services/QuizService.js";
import AppliedStudentsView from "./AppliedStudentsView.jsx";

import {
  getOrganizations,
  updateOrganization,
} from "../../../../services/organizationServices.js";

// Import the CSS file for styling (same as PlacementPopup)
import "../../placement/placementpopup/PlacementPopup.css";
import PlacementPopupView from "../../placement/placementpopup/PlacementPopupView.jsx";
import OrganizationPopupView from "../../organization/organizationpopup/OrganizationPopupView.jsx";
import { getPlacementOfficers } from "../../../../services/PlacementOfficerServices.js";
import { getContacts } from "../../../../services/contactServices.js";
import { getBatches } from "../../../../services/BatchService";
import { getPlacements } from "../../../../services/placementServices.js";
import { getcourses, getDepartmentsV2, getBranchesV2 } from "../../../../services/CourseModule.js";

const StudentPopupView = ({
  student,
  isVisible,
  onClose,
  onCloseAll,
  onUpdate,
  users: externalUsers = [],
  contacts: externalContacts = [],
  courses: externalCourses = [],
  departments: externalDepartments = [],
  branches: externalBranches = [],
  batches: externalBatches = [],
  jobProfiles: externalJobProfiles = [],
  defaultActiveTab = "details",
}) => {
  const [localUsers, setLocalUsers] = useState([]);
  const [localContacts, setLocalContacts] = useState([]);
  const [localCourses, setLocalCourses] = useState([]);
  const [localDepartments, setLocalDepartments] = useState([]);
  const [localBranches, setLocalBranches] = useState([]);
  const [localBatches, setLocalBatches] = useState([]);
  const [localJobProfiles, setLocalJobProfiles] = useState([]);

  const users = localUsers.length > 0 ? localUsers : (externalUsers || []);
  const contacts = localContacts.length > 0 ? localContacts : (externalContacts || []);
  const courses = localCourses.length > 0 ? localCourses : (externalCourses || []);
  const departments = localDepartments.length > 0 ? localDepartments : (externalDepartments || []);
  const branches = localBranches.length > 0 ? localBranches : (externalBranches || []);
  const batches = localBatches.length > 0 ? localBatches : (externalBatches || []);
  const jobProfiles = localJobProfiles.length > 0 ? localJobProfiles : (externalJobProfiles || []);

  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const [originalFormData, setOriginalFormData] = useState({});

  // ── Tab-wise API data ──────────────────────────────────────────────────────
  const [quizData, setQuizData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [appliedJobsData, setAppliedJobsData] = useState([]);

  // ── Loading flags ──────────────────────────────────────────────────────────
  const [loadingQuiz, setLoadingQuiz] = useState(false);
  const [loadingAttendance, setLoadingAttendance] = useState(false);
  const [loadingAppliedJobs, setLoadingAppliedJobs] = useState(false);
  const [loadingTab, setLoadingTab] = useState(false);

  // ── Loaded flags (to avoid re-fetching) ───────────────────────────────────
  const [quizDataLoaded, setQuizDataLoaded] = useState(false);
  const [attendanceDataLoaded, setAttendanceDataLoaded] = useState(false);
  const [appliedJobsDataLoaded, setAppliedJobsDataLoaded] = useState(false);

  const [isStarred, setIsStarred] = useState(false);
  const [error, setError] = useState(null);

  const [jobTitleFilter, setJobTitleFilter] = useState("");
  const [companyFilter, setCompanyFilter] = useState("");

  const [showAppliedStudentsModal, setShowAppliedStudentsModal] = useState(false);
  const [selectedJobProfile, setSelectedJobProfile] = useState(null);

  // Resume download modal
  const [showDownloadResumeModal, setShowDownloadResumeModal] = useState(false);
  const [resumeDownloadOptions, setResumeDownloadOptions] = useState([]);

  const [showPlacementPopup, setShowPlacementPopup] = useState(false);
  const [selectedPlacementForPopup, setSelectedPlacementForPopup] = useState(null);
  const [defaultActiveTabForPlacement, setDefaultActiveTabForPlacement] = useState("summary");

  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganizationForPopup, setSelectedOrganizationForPopup] = useState(null);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [defaultActiveOrgTab, setDefaultActiveOrgTab] = useState("summary");

  const fetchState = useRef({ metadata: false, appliedJobs: false, quiz: false, attendance: false });
  const lastStudentId = useRef(null);

  // ── Helper: get student id ─────────────────────────────────────────────────
  const getStudentId = () => {
    const sid = student?.studentId;
    // Prioritize the nested student ID from the studentId array (e.g., "68375e05...")
    if (Array.isArray(sid) && sid.length > 0) {
      return sid[0]?.id || sid[0];
    }
    // Fallback to top-level id only if nested array is missing
    return student?.id || "";
  };



  // ── Tab-wise API fetch ─────────────────────────────────────────────────────
  const fetchTabData = async (tab) => {
    const studentId = getStudentId();
    if (!studentId) return;

    const payload = { tab, studentId };

    try {
      switch (tab) {
        case "attendance": {
          if (attendanceDataLoaded || loadingAttendance) return;
          fetchState.current.attendance = true;
          setLoadingAttendance(true);
          const response = await getStudentTabWiseInfo(payload);
          const data = response?.data || [];

          // Normalize attendance data
          const normalizedBatchData = Array.isArray(data) ? data.map(item => {
            const bInfo = Array.isArray(item.batchId) && item.batchId.length > 0 ? item.batchId[0] : item.batchId;
            const cInfo = (bInfo && Array.isArray(bInfo.courseId) && bInfo.courseId.length > 0) ? bInfo.courseId[0] : null;

            return {
              batchId: bInfo?.id || bInfo,
              batchName: bInfo?.name || "N/A",
              courseName: cInfo?.name || "N/A",
              totalDays: item.totalDays || 0,
              attendedDays: item.attendedDays || 0,
              percentage: item.percentage || 0
            };
          }) : [];

          setAttendanceData(normalizedBatchData);
          setAttendanceDataLoaded(true);
          setLoadingAttendance(false);
          break;
        }
        case "quiz": {
          if (quizDataLoaded || loadingQuiz) return;
          fetchState.current.quiz = true;
          setLoadingQuiz(true);
          const response = await getStudentTabWiseInfo(payload);
          setQuizData(response?.data || []);
          setQuizDataLoaded(true);
          setLoadingQuiz(false);
          break;
        }
        case "applied-jobs": {
          if (appliedJobsDataLoaded || loadingAppliedJobs) return;
          fetchState.current.appliedJobs = true;
          setLoadingAppliedJobs(true);
          const response = await getStudentTabWiseInfo({ ...payload, tab: "appliedJobs" });
          const records = response?.data || [];
          const allJobs = [];
          records.forEach((record) => {
            const jobProfileIds = record.jobProfileId || [];
            jobProfileIds.forEach((job) => {
              if (!allJobs.find((j) => j.id === job.id)) {
                allJobs.push({
                  ...job,
                  organizationName: job.organizationId?.[0]?.name || "N/A",
                  organizationId: job.organizationId?.[0]?.id || null,
                  departmentName: job.department?.[0]?.name || "N/A",
                  departmentId: job.department?.[0]?.id || null,
                  cvUpload: record.cvUpload || "",
                  studentName: record.studentName || "",
                });
              }
            });
          });
          setAppliedJobsData(allJobs);
          setAppliedJobsDataLoaded(true);
          setLoadingAppliedJobs(false);
          break;
        }
        default:
          break;
      }
    } catch (error) {
      console.error(`Error fetching tab data for ${tab}:`, error);
      toast.error(`Failed to load ${tab} data: ` + error.message);
      setLoadingQuiz(false);
      setLoadingAttendance(false);
      setLoadingAppliedJobs(false);
    }
  };

  // Helper functions to get names by ID
  const getCourseNameById = (course) => {
    if (!course) return "N/A";
    const name = Array.isArray(course) ? course[0]?.courseName || course[0]?.name : (typeof course === 'object' ? course?.courseName || course?.name : null);
    if (name) return name;
    if (typeof course === 'string') {
      if (course.length !== 24 || !/^[0-9a-fA-F]+$/.test(course)) return course;
    }
    const courseId = Array.isArray(course) ? course[0]?.id : (typeof course === 'object' ? course?.id : course);
    if (!courseId || !courses.length) return "N/A";
    const matchedCourse = courses.find((c) => c.id === parseInt(courseId) || c.id === courseId);
    return matchedCourse ? matchedCourse.courseName || matchedCourse.name : "N/A";
  };

  const getCourseNameByCourseModuleId = (course) => {
    if (!course) return "N/A";
    const name = Array.isArray(course) ? course[0]?.courseName || course[0]?.name : (typeof course === 'object' ? course?.courseName || course?.name : null);
    if (name) return name;
    if (typeof course === 'string') {
      if (course.length !== 24 || !/^[0-9a-fA-F]+$/.test(course)) return course;
    }
    const courseId = Array.isArray(course) ? course[0]?.id : (typeof course === 'object' ? course?.id : course);
    if (!courseId || !courses.length) return "N/A";
    const matchedCourse = courses.find((c) => {
      if (c.courseModuleIds === courseId || c.courseModuleIds === courseId.toString()) return true;
      if (typeof c.courseModuleIds === "string" && c.courseModuleIds.includes(courseId.toString())) return true;
      return false;
    });
    return matchedCourse ? matchedCourse.courseName || matchedCourse.name : "N/A";
  };

  const getDepartmentNameById = (dept) => {
    if (!dept) return "N/A";
    const name = Array.isArray(dept) ? dept[0]?.name || dept[0]?.departmentName : (typeof dept === 'object' ? dept?.name || dept?.departmentName : null);
    if (name && typeof name === 'string') return name;
    if (typeof dept === 'string') {
      if (dept.length !== 24 || !/^[0-9a-fA-F]+$/.test(dept)) return dept;
    }
    const departmentId = Array.isArray(dept) ? dept[0]?.id : (typeof dept === 'object' ? dept?.id : dept);
    const finalId = (typeof departmentId === 'object' && departmentId !== null) ? departmentId.id : departmentId;
    if (!finalId || !departments.length) return "N/A";
    const department = departments.find((d) => {
      const targetId = d.id;
      return targetId === finalId || targetId === parseInt(finalId) || targetId === String(finalId);
    });
    if (department) return department.departmentName || department.name || "Unknown";
    return "N/A";
  };

  const loadOrganizations = async () => {
    try {
      const response = await getOrganizations(1000, 1, "");
      if (response && response.data && Array.isArray(response.data)) {
        setOrganizations(response.data);
      } else {
        setOrganizations([]);
      }
    } catch (error) {
      console.error("Failed to load organizations:", error);
      setOrganizations([]);
    }
  };

  const getBranchNameById = (branch) => {
    if (!branch) return "N/A";
    const name = Array.isArray(branch) ? branch[0]?.name || branch[0]?.branchName : (typeof branch === 'object' ? branch?.name || branch?.branchName : null);
    if (name && typeof name === 'string') return name;
    if (typeof branch === 'string') {
      if (branch.length !== 24 || !/^[0-9a-fA-F]+$/.test(branch)) return branch;
    }
    const branchId = Array.isArray(branch) ? branch[0]?.id : (typeof branch === 'object' ? branch?.id : branch);
    const finalId = (typeof branchId === 'object' && branchId !== null) ? branchId.id : branchId;
    if (!finalId || !branches.length) return "N/A";
    const foundBranch = branches.find((b) => {
      const targetId = b.id;
      return targetId === finalId || targetId === parseInt(finalId) || targetId === String(finalId);
    });
    if (foundBranch) return foundBranch.branchName || foundBranch.name || "Unknown";
    return "N/A";
  };

  const handleCommentsError = (error) => {
    setError(error);
  };

  const getFilteredAppliedJobs = () => {
    if (!appliedJobsData.length) return [];
    return appliedJobsData.filter((job) => {
      const jobTitleMatch = jobTitleFilter === "" || job.jobName?.toLowerCase().includes(jobTitleFilter.toLowerCase());
      const companyMatch = companyFilter === "" || job.organizationName?.toLowerCase().includes(companyFilter.toLowerCase());
      return jobTitleMatch && companyMatch;
    });
  };

  const getDepartmentOptions = () => {
    return departments.map((dept) => ({
      value: dept.id,
      label: dept.departmentName || dept.name,
    }));
  };

  const getBranchOptions = () => {
    return branches.map((branch) => ({
      value: branch.id,
      label: branch.branchName || branch.name,
    }));
  };

  const getCourseOptions = (excludeValues = []) => {
    return courses
      .filter((course) => !excludeValues.includes(course.id))
      .map((course) => ({
        value: course.id,
        label: course.courseName || course.name,
      }));
  };

  const getSelectedDepartmentOption = () => {
    if (!formData.department) return null;
    return getDepartmentOptions().find((option) => option.value === formData.department);
  };

  const getSelectedBranchOption = () => {
    if (!formData.selectBranch) return null;
    return getBranchOptions().find((option) => option.value === formData.selectBranch);
  };

  const getSelectedCourseOption = (courseField) => {
    if (!formData[courseField]) return null;
    const allCourseOptions = courses.map((course) => ({
      value: course.id,
      label: course.courseName || course.name,
    }));
    return allCourseOptions.find((option) => option.value === formData[courseField]);
  };

  const handleJobProfileClick = (job) => {
    setSelectedJobProfile(job);
    setShowAppliedStudentsModal(true);
  };

  const handleCloseAllModals = () => {
    setShowAppliedStudentsModal(false);
    setSelectedJobProfile(null);
    if (onCloseAll) {
      onCloseAll();
    } else {
      onClose();
    }
  };

  const handleUpdatePlacementFromPopup = async (updatedPlacement) => {
    try {
      toast.success(`Placement "${updatedPlacement.jobName}" updated successfully!`);
      setAppliedJobsData((prevData) =>
        prevData.map((job) => (job.id === updatedPlacement.id ? updatedPlacement : job))
      );
    } catch (error) {
      toast.error("Failed to update placement: " + error.message);
    }
  };

  const handleJobClickForPlacement = (job) => {
    try {
      setSelectedPlacementForPopup(job);
      setDefaultActiveTabForPlacement("summary");
      setShowPlacementPopup(true);
    } catch (error) {
      console.error("Error opening placement details:", error);
      toast.error("Failed to open placement details");
    }
  };

  const handleViewOrganization = (organizationId) => {
    const organization = organizations.find((org) => org.id === organizationId);
    if (organization) {
      setSelectedOrganizationForPopup(organization);
      setDefaultActiveOrgTab("summary");
      setShowOrganizationPopup(true);
    }
  };

  const handleCloseOrganizationPopup = () => {
    setShowOrganizationPopup(false);
    setSelectedOrganizationForPopup(null);
    setDefaultActiveOrgTab("summary");
  };

  const handleUpdateOrganization = async (updatedOrganization) => {
    try {
      await updateOrganization(updatedOrganization.id, updatedOrganization);
      await loadOrganizations();
      setSelectedOrganizationForPopup(updatedOrganization);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const fetchAllMetadata = async () => {
    if (fetchState.current.metadata) return;
    fetchState.current.metadata = true;
    try {
      const [usersRes, contactsRes, coursesRes, deptsRes, branchesRes, batchesRes, jobsRes] = await Promise.all([
        getPlacementOfficers(500, 1),
        getContacts(),
        getcourses(1000, 1),
        getDepartmentsV2(1000, 1),
        getBranchesV2(1000),
        getBatches(1000, 1),
        getPlacements()
      ]);
      if (usersRes?.data) setLocalUsers(usersRes.data);
      if (contactsRes?.data) setLocalContacts(contactsRes.data);
      if (coursesRes?.data) setLocalCourses(coursesRes.data);
      if (deptsRes?.data || deptsRes) setLocalDepartments(deptsRes?.data || deptsRes);
      if (branchesRes) setLocalBranches(branchesRes);
      if (batchesRes?.data) setLocalBatches(batchesRes.data);
      if (jobsRes?.data) setLocalJobProfiles(jobsRes.data);
    } catch (error) {
      console.error("Error fetching metadata in StudentPopView:", error);
    }
  };

  useEffect(() => {
    if (student) {
      const sid = student.studentId;
      const studentId = student.id || (Array.isArray(sid) && sid.length > 0 ? (sid[0]?.id || sid[0]) : (sid?.id || sid));
      const studentName = student.studentName || (Array.isArray(student.studentId) ? student.studentId[0]?.name : "") || "N/A";
      const studentEmail = student.studentEmail || (Array.isArray(student.studentId) ? student.studentId[0]?.email : "") || "N/A";
      const studentPhoneNumber = student.studentPhoneNumber || (Array.isArray(student.studentId) ? student.studentId[0]?.phone : "") || "N/A";

      const studentData = {
        id: student.id || "",
        studentName: studentName,
        studentId: studentId,
        studentEmail: studentEmail,
        studentPhoneNumber: studentPhoneNumber,
        department: (Array.isArray(student.department) ? student.department[0]?.id : (typeof student.department === 'object' ? student.department?.id : student.department)) || "",
        technologiesLearned: student.technologiesLearned || "",
        addressWithPinCode: student.addressWithPinCode || "",
        tenthPercentageAndYear: student.tenthPercentageAndYear || "",
        twelfthPercentageAndYear: student.twelfthPercentageAndYear || "",
        workExperience: student.workExperience || "",
        course1: student.course1 || "",
        course2: student.course2 || "",
        course3: student.course3 || "",
        graduationPercentageAndYear: student.graduationPercentageAndYear || "",
        oneTimePlacementFee: student.oneTimePlacementFee || "",
        selectBranch: (Array.isArray(student.selectBranch) ? student.selectBranch[0]?.id : (typeof student.selectBranch === 'object' ? student.selectBranch?.id : student.selectBranch)) || "",
        postGraduationPercentageAndYear: student.postGraduationPercentageAndYear || "",
        cvUpload: student.cvUpload || "",
        jobProfileId: (Array.isArray(student.jobProfileId) ? student.jobProfileId[0]?.id : student.jobProfileId) || "",
        createdById: student.createdById || "",
        updatedById: student.updatedById || "",
      };
      setFormData(studentData);
      setOriginalFormData(studentData);

      const isNewStudent = lastStudentId.current !== studentId;
      if (isNewStudent) {
        lastStudentId.current = studentId;
        fetchState.current = { metadata: false, appliedJobs: false, quiz: false, attendance: false };
        // Reset all tab data
        setQuizData([]);
        setAttendanceData([]);
        setAppliedJobsData([]);
        setQuizDataLoaded(false);
        setAttendanceDataLoaded(false);
        setAppliedJobsDataLoaded(false);
        setJobTitleFilter("");
        setCompanyFilter("");
      }
    }
    setActiveTab(defaultActiveTab);
    setEditMode(defaultActiveTab === "edit");
  }, [student?.id, student?.studentId, defaultActiveTab]);

  useEffect(() => {
    if (isVisible) {
      // Always fetch applied-jobs for the sidebar if not already loaded
      if (!fetchState.current.appliedJobs) {
        fetchTabData("applied-jobs");
      }

      if (activeTab === "details") {
        // No extra fetch for details — data comes from props
      } else if (activeTab === "edit") {
        fetchAllMetadata();
      } else if (activeTab === "applied-jobs") {
        // Handled above
      } else if (activeTab === "quiz") {
        if (!fetchState.current.quiz) {
          fetchTabData("quiz");
        }
      } else if (activeTab === "attendance") {
        if (!fetchState.current.attendance) {
          fetchTabData("attendance");
        }
      }
    }
  }, [isVisible, activeTab, student?.id]);

  const handleTabSelect = (key) => {
    setLoadingTab(true);
    setTimeout(() => {
      setActiveTab(key);
      setEditMode(key === "edit");
      setLoadingTab(false);
    }, 500);
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      await onUpdate(formData);
      setEditMode(false);
      toast.success("Student updated successfully!");
      handleCloseAllModals();
    } catch (error) {
      toast.error("Failed to update student: " + error.message);
    }
  };

  const handleCancel = () => {
    setFormData(originalFormData);
    setEditMode(false);
    handleCloseAllModals();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ── Resume Download ────────────────────────────────────────────────────────
  const handleDownloadCVClick = () => {
    if (!student.cvUpload) {
      toast.error("No resume available for download");
      return;
    }
    if (appliedJobsData && appliedJobsData.length > 1) {
      const options = appliedJobsData.map((job) => ({
        id: job.id || job.jobProfileId,
        jobName: job.jobName,
        organizationName: job.organizationName,
        salary: job.salary,
        jobProfileId: job.jobProfileId,
      }));
      setResumeDownloadOptions(options);
      setShowDownloadResumeModal(true);
    } else if (appliedJobsData && appliedJobsData.length === 1) {
      performCVDownload();
    } else {
      performCVDownload();
    }
  };

  const performCVDownload = (jobInfo = null) => {
    if (student.cvUpload) {
      const link = document.createElement("a");
      const cvUrl = `${student.cvUpload}`;
      link.href = getResumeDownloadUrl(cvUrl);
      let filename = `${student.studentName}_Resume`;
      if (jobInfo && jobInfo.jobName) filename += `_${jobInfo.jobName}`;
      filename += ".pdf";
      link.download = filename;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Resume download started!");
      setShowDownloadResumeModal(false);
      setResumeDownloadOptions([]);
    } else {
      toast.error("No resume available for download");
    }
  };

  const handleCopyStudent = () => {
    navigator.clipboard.writeText(student.studentName);
    toast.success("Student name copied to clipboard!");
  };

  const handleShareStudent = () => {
    toast.info("Share functionality to be implemented");
  };

  const handleEditStudent = () => {
    setActiveTab("edit");
    setEditMode(true);
  };

  const handleEmail = () => {
    if (student.studentEmail) window.location.href = `mailto:${student.studentEmail}`;
  };

  const handleCall = () => {
    if (student.studentPhoneNumber) window.location.href = `tel:${student.studentPhoneNumber}`;
  };

  const tabs = [
    { key: "details", label: "Details", icon: User },
    { key: "quiz", label: "Quiz Performance", icon: Trophy },
    { key: "attendance", label: "Attendance", icon: UserCheck },
    { key: "applied-jobs", label: "Applied Jobs", icon: Briefcase },
  ];

  const visibleTabs = tabs.slice(0, 6);
  const hiddenTabs = tabs.slice(6);

  const TabIcon = ({ icon: Icon, active }) => (
    <Icon size={16} color={active ? "#ea580c" : "#6c757d"} style={{ marginRight: "6px" }} />
  );

  const renderTabContent = () => {
    if (loadingTab) {
      return (
        <div style={{ textAlign: "center", padding: "60px 20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "300px" }}>
          <Spinner animation="border" style={{ color: "#f97316", width: "2.5rem", height: "2.5rem", borderWidth: "3px" }} />
          <p style={{ marginTop: "16px", color: "#6c757d" }}>Loading...</p>
        </div>
      );
    }
    switch (activeTab) {
      case "details": return renderDetailsTab();
      case "edit": return renderEditTab();
      case "quiz": return renderQuizTab();
      case "attendance": return renderAttendanceTab();
      case "applied-jobs": return renderAppliedJobsTab();
      default: return renderDetailsTab();
    }
  };

  const renderEditTab = () => (
    <div className="edit-student-content">
      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formStudentName">
              <Form.Label>Student Name</Form.Label>
              <Form.Control type="text" value={formData.studentName} onChange={(e) => handleInputChange("studentName", e.target.value)} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formStudentEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" value={formData.studentEmail} onChange={(e) => handleInputChange("studentEmail", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formDepartment">
              <Form.Label>Department</Form.Label>
              <AsyncSelectDropdown
                options={getDepartmentOptions()}
                value={getSelectedDepartmentOption()}
                onChange={(selectedOption) => handleInputChange("department", selectedOption ? selectedOption.value : "")}
                placeholder="Select the Department"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formStudentPhoneNumber">
              <Form.Label>Phone</Form.Label>
              <Form.Control type="tel" value={formData.studentPhoneNumber} onChange={(e) => handleInputChange("studentPhoneNumber", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formSelectBranch">
              <Form.Label>Branch</Form.Label>
              <AsyncSelectDropdown
                options={getBranchOptions()}
                value={getSelectedBranchOption()}
                onChange={(selectedOption) => handleInputChange("selectBranch", selectedOption ? selectedOption.value : "")}
                placeholder="Select the Branch"
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formWorkExperience">
              <Form.Label>Experience</Form.Label>
              <Form.Control type="text" value={formData.workExperience} onChange={(e) => handleInputChange("workExperience", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-3" controlId="formTechnologiesLearned">
              <Form.Label>Technologies</Form.Label>
              <Form.Control type="text" value={formData.technologiesLearned} onChange={(e) => handleInputChange("technologiesLearned", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formTenthPercentageAndYear">
              <Form.Label>10th Grade</Form.Label>
              <Form.Control type="text" value={formData.tenthPercentageAndYear} onChange={(e) => handleInputChange("tenthPercentageAndYear", e.target.value)} />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formTwelfthPercentageAndYear">
              <Form.Label>12th Grade</Form.Label>
              <Form.Control type="text" value={formData.twelfthPercentageAndYear} onChange={(e) => handleInputChange("twelfthPercentageAndYear", e.target.value)} />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formGraduationPercentageAndYear">
              <Form.Label>Graduation</Form.Label>
              <Form.Control type="text" value={formData.graduationPercentageAndYear} onChange={(e) => handleInputChange("graduationPercentageAndYear", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formOneTimePlacementFee">
              <Form.Label>Placement Fee</Form.Label>
              <Form.Control type="text" value={formData.oneTimePlacementFee} onChange={(e) => handleInputChange("oneTimePlacementFee", e.target.value)} />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="formPostGraduationPercentageAndYear">
              <Form.Label>Post Graduation</Form.Label>
              <Form.Control type="text" value={formData.postGraduationPercentageAndYear} onChange={(e) => handleInputChange("postGraduationPercentageAndYear", e.target.value)} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formCourse1">
              <Form.Label>Course 1</Form.Label>
              <AsyncSelectDropdown
                options={getCourseOptions([formData.course2, formData.course3])}
                value={getSelectedCourseOption("course1")}
                onChange={(selectedOption) => handleInputChange("course1", selectedOption ? selectedOption.value : "")}
                placeholder="Select the course"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formCourse2">
              <Form.Label>Course 2</Form.Label>
              <AsyncSelectDropdown
                options={getCourseOptions([formData.course1, formData.course3])}
                value={getSelectedCourseOption("course2")}
                onChange={(selectedOption) => handleInputChange("course2", selectedOption ? selectedOption.value : "")}
                placeholder="Select the course"
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3" controlId="formCourse3">
              <Form.Label>Course 3</Form.Label>
              <AsyncSelectDropdown
                options={getCourseOptions([formData.course1, formData.course2])}
                value={getSelectedCourseOption("course3")}
                onChange={(selectedOption) => handleInputChange("course3", selectedOption ? selectedOption.value : "")}
                placeholder="Select the course"
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
          <Button variant="success" onClick={handleSave} className="px-4">Save Changes</Button>
          <Button variant="secondary" onClick={handleCancel} className="px-4">Cancel</Button>
        </div>
      </Form>
    </div>
  );

  // ── Details Tab: uses props data (unchanged) ───────────────────────────────
  const renderDetailsTab = () => (
    <div className="student-summary-content">
      {error && (
        <Alert variant="danger" className="mb-4" dismissible onClose={() => setError(null)}>
          <AlertCircle size={16} className="me-2" />
          {error}
        </Alert>
      )}

      <Row className="student-header-row">
        <Col md={2}><span className="field-label">Student Name</span></Col>
        <Col md={3}><span className="field-label">Email</span></Col>
        <Col md={2}><span className="field-label">Department</span></Col>
        <Col md={2}><span className="field-label">Phone</span></Col>
        <Col md={3}><span className="field-label">Branch</span></Col>
      </Row>

      <Row className="student-data-row">
        <Col md={2}>
          <div className="field-value">
            {student.studentName || (Array.isArray(student.studentId) ? student.studentId[0]?.name : "N/A")}
          </div>
        </Col>
        <Col md={3}>
          <div className="field-value" style={{ wordBreak: "break-all", whiteSpace: "normal", overflowWrap: "anywhere" }}>
            {student.studentEmail || (Array.isArray(student.studentId) ? student.studentId[0]?.email : "N/A")}
          </div>
        </Col>
        <Col md={2}>
          <div className="field-value">
            {student.departmentName || getDepartmentNameById(student.department)}
          </div>
        </Col>
        <Col md={2}>
          <div className="field-value">
            {student.studentPhoneNumber || (Array.isArray(student.studentId) ? student.studentId[0]?.phone : "N/A")}
          </div>
        </Col>
        <Col md={3}>
          <div className="field-value">
            {student.branchName || getBranchNameById(student.selectBranch)}
          </div>
        </Col>
        <Col md={2}>
          <div className="field-value">{student.workExperience || "No experience"}</div>
        </Col>
      </Row>

      <Row className="student-additional-row mt-3">
        <Col md={2}>
          <span className="field-label">Technologies</span>
          <div className="field-value">{student.technologiesLearned || "Not specified"}</div>
        </Col>
        <Col md={2}>
          <span className="field-label">10th Grade</span>
          <div className="field-value">{student.tenthPercentageAndYear || "Not specified"}</div>
        </Col>
        <Col md={2}>
          <span className="field-label">12th Grade</span>
          <div className="field-value">{student.twelfthPercentageAndYear || "Not specified"}</div>
        </Col>
        <Col md={2}>
          <span className="field-label">Graduation</span>
          <div className="field-value">{student.graduationPercentageAndYear || "Not specified"}</div>
        </Col>
        <Col md={2}>
          <span className="field-label">Placement Fee</span>
          <div className="field-value">{student.oneTimePlacementFee || "Not specified"}</div>
        </Col>
        <Col md={2}>
          <span className="field-label">Applied Date</span>
          <div className="field-value">
            {student.createdAt ? new Date(student.createdAt).toLocaleDateString() : "N/A"}
          </div>
        </Col>
      </Row>

      <div className="courses-section">
        <h6>Enrolled Courses</h6>
        <div className="courses-details">
          {student.course1 && <p><strong>Course 1:</strong> {getCourseNameByCourseModuleId(student.course1)}</p>}
          {student.course2 && <p><strong>Course 2:</strong> {getCourseNameByCourseModuleId(student.course2)}</p>}
          {student.course3 && <p><strong>Course 3:</strong> {getCourseNameByCourseModuleId(student.course3)}</p>}
          {!student.course1 && !student.course2 && !student.course3 && (
            <p className="text-muted">No courses enrolled</p>
          )}
        </div>
      </div>

      {student.id && (
        <CommentsSection
          entityId={student.id}
          type="jobapplied"
          title={`Discussion about ${student.studentName}`}
          users={users}
          onError={handleCommentsError}
          showCollapse={true}
          defaultExpanded={true}
          maxHeight="500px"
          className="student-comments-section"
        />
      )}
    </div>
  );

  // ── Quiz Tab: uses quizData from tab-wise API ──────────────────────────────
  const renderQuizTab = () => (
    <div className="quiz-performance">
      <div className="d-flex align-items-center mb-3">
        <Trophy size={20} className="me-2 text-warning" />
        <h5 className="mb-0">Quiz Performance</h5>
      </div>

      {loadingQuiz ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Loading quiz data...</p>
        </div>
      ) : quizData.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-hover table-sm">
            <thead className="table-primary">
              <tr>
                <th>Quiz Name</th>
                <th>Score</th>
                <th>Out Of</th>
                <th>Result</th>
                <th>Time Taken</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Submitted On</th>
              </tr>
            </thead>
            <tbody>
              {quizData.map((quiz, index) => {
                // Ensure we handle the quiz details correctly from the nested structure
                const quizInfo = (Array.isArray(quiz.quizId) ? quiz.quizId[0] : (quiz.quizId || {})) || {};
                
                const title = quizInfo.title || quizInfo.name || quiz.quizName || "Unknown Quiz";
                const start = quizInfo.startDate || quiz.startDate;
                const end = quizInfo.endDate || quiz.endDate;

                const formatDateString = (dateStr) => {
                  if (!dateStr || dateStr === "NA" || dateStr === "N/A") return "N/A";
                  const d = new Date(dateStr);
                  return isNaN(d.getTime()) ? "N/A" : d.toLocaleDateString();
                };

                return (
                  <tr key={quiz.id || index}>
                    <td className="fw-bold text-dark">{title}</td>
                    <td>
                      <strong className="text-primary">{quiz.scored ?? "N/A"}</strong>
                    </td>
                    <td>{quiz.outOf ?? "N/A"}</td>
                    <td>
                      {quiz.result === "Pass" ? (
                        <span className="badge bg-success px-2 py-1">Pass</span>
                      ) : (
                        <span className="badge bg-danger px-2 py-1">Fail</span>
                      )}
                    </td>
                    <td className="text-muted">{quiz.timeConsumed || "N/A"}</td>
                    <td className="text-muted">{formatDateString(start)}</td>
                    <td className="text-muted">{formatDateString(end)}</td>
                    <td className="text-muted">{formatDateString(quiz.createdAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info">
          <Trophy size={16} className="me-2" />
          No quiz attempts found for this student.
        </div>
      )}
    </div>
  );

  // ── Attendance Tab: uses attendanceData from tab-wise API ──────────────────
  const renderAttendanceTab = () => {
    const getAttendanceVariant = (pct) => {
      const p = parseFloat(pct);
      if (p >= 80) return "success";
      if (p >= 60) return "warning";
      return "danger";
    };

    const totalDays = attendanceData.reduce((sum, b) => sum + (b.totalDays || 0), 0);
    const totalAttended = attendanceData.reduce((sum, b) => sum + (b.attendedDays || 0), 0);
    const totalAbsent = totalDays - totalAttended;
    const overallPct = totalDays > 0 ? ((totalAttended / totalDays) * 100).toFixed(2) : 0;

    return (
      <div className="attendance-summary">
        <div className="d-flex align-items-center mb-3">
          <UserCheck size={20} className="me-2 text-success" />
          <h5 className="mb-0">Attendance Summary</h5>
        </div>

        {loadingAttendance ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
            <p className="mt-2">Loading attendance data...</p>
          </div>
        ) : attendanceData.length > 0 ? (
          <>
            <Row className="mb-3">
              <Col md={3} xs={6} className="mb-2">
                <div className="text-center p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-1 text-primary">{totalDays}</h5>
                  <small className="text-muted fw-semibold">Total Classes</small>
                </div>
              </Col>
              <Col md={3} xs={6} className="mb-2">
                <div className="text-center p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-1 text-success">{totalAttended}</h5>
                  <small className="text-muted fw-semibold">Present</small>
                </div>
              </Col>
              <Col md={3} xs={6} className="mb-2">
                <div className="text-center p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-1 text-danger">{totalAbsent}</h5>
                  <small className="text-muted fw-semibold">Absent</small>
                </div>
              </Col>
              <Col md={3} xs={6} className="mb-2">
                <div className="text-center p-3 bg-light rounded shadow-sm">
                  <h5 className="mb-1 text-info">{overallPct}%</h5>
                  <small className="text-muted fw-semibold">Overall Attendance</small>
                </div>
              </Col>
            </Row>

            <div className="batch-wise-attendance mt-4">
              <h6 className="mb-3">Batch-wise Attendance Details</h6>
              {attendanceData.map((batchData, index) => (
                <div key={batchData.batchId || index} className="batch-card mb-3 p-3 border rounded">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0 text-primary">
                      <i className="fas fa-users me-2"></i>
                      {batchData.batchName}
                      {batchData.courseName && batchData.courseName !== "N/A" && (
                        <span style={{ fontWeight: "normal", fontSize: "0.85em", marginLeft: "8px", color: "#6c757d" }}>
                          ({batchData.courseName})
                        </span>
                      )}
                    </h6>
                    <span className={`badge bg-${getAttendanceVariant(batchData.percentage)}`}>
                      {batchData.percentage}%
                    </span>
                  </div>
                  <Row>
                    <Col xs={4}>
                      <div className="text-center">
                        <div className="fw-bold text-primary">{batchData.totalDays}</div>
                        <small className="text-muted">Total</small>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="text-center">
                        <div className="fw-bold text-success">{batchData.attendedDays}</div>
                        <small className="text-muted">Present</small>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="text-center">
                        <div className="fw-bold text-danger">{batchData.totalDays - batchData.attendedDays}</div>
                        <small className="text-muted">Absent</small>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="alert alert-info">
            <UserCheck size={16} className="me-2" />
            No attendance records found for this student.
          </div>
        )}
      </div>
    );
  };

  // ── Applied Jobs Tab: uses appliedJobsData from tab-wise API ──────────────
  const renderAppliedJobsTab = () => {
    const filteredJobs = getFilteredAppliedJobs();

    return (
      <div className="tab-pane-content">
        {loadingAppliedJobs ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
            <p className="mt-2">Loading applied jobs data...</p>
          </div>
        ) : (
          <>
            {appliedJobsData.length > 0 ? (
              <>
                <div className="mb-4 p-3 bg-light rounded">
                  <h6 className="mb-3">
                    <Briefcase size={18} className="me-2" />
                    Filter Applied Jobs
                  </h6>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Filter by Job Title</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Search job titles..."
                          value={jobTitleFilter}
                          onChange={(e) => setJobTitleFilter(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Filter by Company</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Search companies..."
                          value={companyFilter}
                          onChange={(e) => setCompanyFilter(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  {(jobTitleFilter || companyFilter) && (
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">
                        Showing {filteredJobs.length} of {appliedJobsData.length} jobs
                      </small>
                      <Button
                        variant="link"
                        size="sm"
                        onClick={() => { setJobTitleFilter(""); setCompanyFilter(""); }}
                        className="p-0"
                      >
                        Clear Filters
                      </Button>
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <h6>
                    Total Applied Jobs:{" "}
                    <span className="badge bg-primary">{appliedJobsData.length}</span>
                    {filteredJobs.length !== appliedJobsData.length && (
                      <span className="ms-2">
                        Filtered: <span className="badge bg-secondary">{filteredJobs.length}</span>
                      </span>
                    )}
                  </h6>
                </div>

                {filteredJobs.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Job Title</th>
                          <th>Company</th>
                          <th>Location</th>
                          <th>Salary</th>
                          <th>Status</th>
                          <th>Applied Date</th>
                          <th>Department</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredJobs.map((job, index) => (
                          <tr key={job.id || index}>
                            <td>
                              <Button
                                variant="link"
                                className="p-0 text-start"
                                style={{ textDecoration: "none" }}
                                onClick={() => handleJobClickForPlacement(job)}
                              >
                                <strong className="text-primary">{job.jobName}</strong>
                              </Button>
                            </td>
                            <td>{job.organizationName}</td>
                            <td><span className="text-muted">📍 {job.jobLocation}</span></td>
                            <td><span className="text-success font-weight-bold">{job.salary}</span></td>
                            <td>
                              <span
                                className={`badge ${job.status === "active"
                                    ? "bg-success"
                                    : job.status === "inactive"
                                      ? "bg-secondary"
                                      : "bg-warning"
                                  }`}
                              >
                                {job.status}
                              </span>
                            </td>
                            <td>
                              {job.jobPostedDate ? new Date(job.jobPostedDate).toLocaleDateString() : "N/A"}
                            </td>
                            <td>
                              <span className="badge bg-info">{job.departmentName}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info">
                    <Briefcase size={16} className="me-2" />
                    No jobs found matching your filter criteria.
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-4">
                <div className="mb-3"><Briefcase size={48} className="text-muted" /></div>
                <h6 className="text-muted">No Applied Jobs</h6>
                <p className="text-muted">This student hasn't applied for any jobs yet.</p>
              </div>
            )}
          </>
        )}

        <AppliedStudentsView
          jobProfile={selectedJobProfile}
          isVisible={showAppliedStudentsModal}
          onClose={() => {
            setShowAppliedStudentsModal(false);
            setSelectedJobProfile(null);
          }}
          onCloseAll={handleCloseAllModals}
          users={users}
          contacts={contacts}
          courses={courses}
          departments={departments}
          branches={branches}
          batches={batches}
          jobProfiles={jobProfiles}
        />
      </div>
    );
  };

  const renderMainContent = () => {
    if (activeTab === "applied-jobs") {
      return renderAppliedJobsTab();
    }

    return (
      <Row className="h-100" style={{ margin: 0 }}>
        <Col
          md={9}
          style={{
            borderRight: "1px solid #e9ecef",
            paddingRight: "20px",
            height: "calc(90vh - 200px)",
            maxHeight: "700px",
            overflowY: "auto",
          }}
        >
          <div className="tab-content-left">{renderTabContent()}</div>
        </Col>

        <Col
          md={3}
          style={{
            paddingLeft: "20px",
            height: "calc(90vh - 200px)",
            maxHeight: "700px",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="jobs-sidebar">
            <h6 className="mb-3" style={{ fontWeight: "600", fontSize: "16px" }}>
              <Briefcase size={18} className="me-2" style={{ display: "inline" }} />
              Jobs
            </h6>
            {appliedJobsData.length > 0 ? (
              <div>
                <div className="mb-3">
                  <small className="text-muted">
                    Total Applied:{" "}
                    <span className="badge bg-primary">{appliedJobsData.length}</span>
                  </small>
                </div>
                <div className="jobs-list" style={{ maxHeight: "500px", overflowY: "auto" }}>
                  {appliedJobsData.slice(0, 5).map((job, index) => (
                    <div
                      key={index}
                      className="job-card mb-3 p-3"
                      style={{
                        border: "1px solid #e9ecef",
                        borderRadius: "6px",
                        backgroundColor: "#f8f9fa",
                        cursor: "pointer",
                        transition: "all 0.2s",
                      }}
                      onClick={() => handleJobClickForPlacement(job)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#e9ecef";
                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div className="job-title" style={{ fontWeight: "600", marginBottom: "4px" }}>{job.jobName}</div>
                      <div className="job-company" style={{ fontSize: "12px", color: "#6c757d", marginBottom: "4px" }}>{job.organizationName}</div>
                      <div className="job-location" style={{ fontSize: "12px", color: "#6c757d" }}>📍 {job.jobLocation}</div>
                    </div>
                  ))}
                </div>
                {appliedJobsData.length > 5 && (
                  <Button variant="link" size="sm" onClick={() => handleTabSelect("applied-jobs")} className="mt-2">
                    View All Jobs ({appliedJobsData.length})
                  </Button>
                )}
              </div>
            ) : (
              <div className="text-center py-4" style={{ color: "#6c757d" }}>
                <Briefcase size={32} className="mb-2" style={{ opacity: 0.5 }} />
                <p style={{ fontSize: "14px" }}>No Related Placement</p>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  };

  if (!isVisible || !student) return null;

  return (
    <>
      {/* MAIN STUDENT MODAL */}
      <Modal
        show={isVisible}
        onHide={handleCloseAllModals}
        size="xl"
        centered
        className="student-modal"
        backdrop="static"
        dialogClassName="fixed-size-modal"
      >
        <div
          className="modal-container"
          style={{ padding: "20px", minHeight: "600px", maxHeight: "90vh", display: "flex", flexDirection: "column" }}
        >
          <Modal.Header className="student-modal-header" style={{ flexShrink: 0, position: "relative" }}>
            <Button
              variant="link"
              onClick={handleCloseAllModals}
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                zIndex: 1060,
                color: "#6c757d",
                textDecoration: "none",
                border: "none",
                background: "transparent",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                transition: "all 0.2s ease",
              }}
              className="modal-close-x-btn"
              title="Close"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.color = "#212529";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = "#6c757d";
              }}
            >
              <X size={20} />
            </Button>
            <div className="header-content" style={{ paddingRight: "40px" }}>
              <div className="left-section">
                <Button variant="link" onClick={handleCloseAllModals} className="close-btn">
                  <ArrowLeft size={20} />
                </Button>
                <div className="student-info">
                  <div className="student-avatar">
                    {student.studentName?.substring(0, 2)?.toUpperCase() || "ST"}
                  </div>
                  <div>
                    <div className="student-details">
                      <h5 className="student-name">{student.studentName}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="action-buttons">
              </div>
            </div>
          </Modal.Header>

          <div className="tabs-container" style={{ flexShrink: 0 }}>
            <div className="d-flex align-items-center">
              <Nav variant="tabs" className="custom-tabs flex-grow-1">
                {visibleTabs.map((tab) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link
                      active={activeTab === tab.key}
                      onClick={() => handleTabSelect(tab.key)}
                      className="custom-tab-link"
                    >
                      <TabIcon icon={tab.icon} active={activeTab === tab.key} />
                      {tab.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}

                {hiddenTabs.length > 0 && (
                  <Nav.Item className="more-tabs-item">
                    <Dropdown>
                      <Dropdown.Toggle as={Nav.Link} className="more-tabs-link">
                        <span className="tab-count">{hiddenTabs.length}</span> More
                        <ChevronDown size={12} className="more-dropdown-icon" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {hiddenTabs.map((tab) => (
                          <Dropdown.Item
                            key={tab.key}
                            onClick={() => handleTabSelect(tab.key)}
                            className={activeTab === tab.key ? "active" : ""}
                          >
                            <TabIcon icon={tab.icon} active={activeTab === tab.key} />
                            {tab.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav.Item>
                )}

                {student.cvUpload && (
                  <Nav.Item className="download-nav-item">
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleDownloadCVClick}
                      className="download-resume-tab-btn"
                    >
                      <Download size={16} className="me-1" />
                      Download Resume
                    </Button>
                  </Nav.Item>
                )}
              </Nav>
            </div>
          </div>

          <Modal.Body
            className="student-modal-body"
            style={{ flex: 1, overflowY: "hidden", minHeight: 0, padding: "20px" }}
          >
            <div className="full-width-content" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
              {renderMainContent()}
            </div>
          </Modal.Body>
        </div>

        <style>{`
          .fixed-size-modal {
            max-width: 95vw !important;
            width: 95vw !important;
          }
          .fixed-size-modal .modal-content {
            height: 95vh !important;
            max-height: 95vh !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .student-comments-section {
            border: 2px solid #c3e6cb;
            background: linear-gradient(135deg, #f0fff0 0%, #e6ffe6 100%);
            margin-top: 30px;
          }
          .courses-section {
            margin: 30px 0;
            padding: 20px;
            background: #f8f9fa;
            border-radius: 8px;
          }
          .courses-section h6 {
            color: #495057;
            margin-bottom: 15px;
            font-weight: 600;
          }
          .courses-details {
            background: white;
            padding: 20px;
            border-radius: 6px;
            border: 1px solid #e9ecef;
            margin-bottom: 15px;
            line-height: 1.6;
          }
          .download-resume-modal-backdrop {
            background-color: rgba(0, 0, 0, 0.85) !important;
            opacity: 1 !important;
          }
          .download-resume-modal-dialog {
            z-index: 1060 !important;
          }
          .download-resume-modal-dialog .modal-content {
            background-color: #ffffff;
            border-radius: 12px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
            border: none;
          }
        `}</style>
      </Modal>

      {/* RESUME DOWNLOAD MODAL */}
      <Modal
        show={showDownloadResumeModal}
        onHide={() => { setShowDownloadResumeModal(false); setResumeDownloadOptions([]); }}
        centered
        backdrop="static"
        className="download-resume-modal-dialog download-resume-modal-backdrop"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span style={{ fontSize: "1.2em", fontWeight: "500", color: "#333" }}>
              Select Job Profile for Resume Download
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "30px", backgroundColor: "#f9f9f9" }}>
          <p className="text-muted mb-4" style={{ fontSize: "0.95em", color: "#666" }}>
            This student has applied for {resumeDownloadOptions.length} job(s). Click download button on the job to download resume:
          </p>
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            {resumeDownloadOptions.map((option, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "#ffffff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "20px",
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  transition: "all 0.2s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = "#d0d0d0"; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "#e0e0e0"; }}
              >
                <div>
                  <h6 style={{ marginBottom: "8px", fontSize: "1em", fontWeight: "600", color: "#1a1a1a" }}>
                    {option.jobName}
                  </h6>
                  <p style={{ marginBottom: "4px", fontSize: "0.9em", color: "#777", display: "flex", alignItems: "center", gap: "6px" }}>
                    {option.organizationName}
                  </p>
                </div>
                <Button
                  variant="danger"
                  style={{ backgroundColor: "#ff5a7e", border: "none", borderRadius: "6px", padding: "8px 20px", fontSize: "0.9em", fontWeight: "600", display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap", flexShrink: 0 }}
                  onClick={(e) => { e.stopPropagation(); performCVDownload(option); }}
                >
                  <Download size={16} />
                  Download
                </Button>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: "1px solid #e0e0e0", padding: "15px 30px" }}>
          <Button
            variant="secondary"
            style={{ backgroundColor: "#2d3e50", border: "none", borderRadius: "6px", padding: "8px 24px", color: "white", fontWeight: "600" }}
            onClick={() => { setShowDownloadResumeModal(false); setResumeDownloadOptions([]); }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Placement Popup Modal */}
      <PlacementPopupView
        show={showPlacementPopup}
        onHide={() => {
          setShowPlacementPopup(false);
          setSelectedPlacementForPopup(null);
          setDefaultActiveTabForPlacement("summary");
        }}
        placement={selectedPlacementForPopup}
        onUpdatePlacement={handleUpdatePlacementFromPopup}
        defaultTab={defaultActiveTabForPlacement}
        departments={departments}
        branches={branches}
      />

      {/* Organization Popup Modal */}
      {selectedOrganizationForPopup && (
        <OrganizationPopupView
          show={showOrganizationPopup}
          onHide={handleCloseOrganizationPopup}
          organization={selectedOrganizationForPopup}
          onUpdateOrganization={handleUpdateOrganization}
          defaultActiveTab={defaultActiveOrgTab}
        />
      )}
    </>
  );
};

export default StudentPopupView;
